import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import _ from 'lodash';

//utils
import queries from '../../../utils/queries'

import OdeSOS1 from './odesos1';
import OdeSOS2 from './odesos2';
import AddOS1 from './addos1';
import AddOS2 from './addos2';
import VerOS1 from './veros1';
import VerOS2 from './veros2';

class HomeOdeS extends React.Component{
  state={
    showOS: true, addOS: false, verOS: false,

    permiteUpdate: false,
    permiteDelete: false,
    permiteCancel: false,
    permiteClose: false,
    permiteDir: false,
    permiteTar: false,
    permiteOfer: false,
    permiteEqu: false,

    argsAdd: {},
    errorAdd: [],

    idListaOS: {},
    lisSup: [], lisInf: [], lisSupIni: [], lisInfIni: [],
    argsBuscar: {contrato: this.props.contrato},
    hoy: ""
  }

  validarHandle = (campo1, campo1Val, campo1Sel, campo1Msg,
    campo2, campo2Val, campo2Sel, campo2Msg,
    campo3, campo3Val, campo3Sel, campo3Msg,
    campo4, campo4Val, campo4Sel, campo4Msg,
    campo5, campo5Val, campo5Sel, campo5Msg,
    campo6, campo6Val, campo6Sel, campo6Msg,
    campo7, campo7Val, campo7Sel, campo7Msg,
    campo8, campo8Val, campo8Sel, campo8Msg)=>{

    const argsAdd = this.state.argsAdd
    const errors = [];
    if(campo1!=='XXX' && (!campo1 || campo1===campo1Sel)){
      argsAdd[campo1Val] = campo1Sel;
      errors.push({path: campo1Val, message: campo1Msg});
    }
    if(campo2!=='XXX' && (!campo2 || campo2===campo2Sel)){
      argsAdd[campo2Val] = campo2Sel;
      errors.push({path: campo2Val, message: campo2Msg});
    }
    if(campo3!=='XXX' && (!campo3 || campo3===campo3Sel)){
      argsAdd[campo3Val] = campo3Sel;
      errors.push({path: campo3Val, message: campo3Msg});
    }
    if(campo4!=='XXX' && (!campo4 || campo4===campo4Sel)){
      argsAdd[campo4Val] = campo4Sel;
      errors.push({path: campo4Val, message: campo4Msg});
    }
    if(campo5!=='XXX' && (!campo5 || campo5===campo5Sel)){
      argsAdd[campo5Val] = campo5Sel;
      errors.push({path: campo5Val, message: campo5Msg});
    }
    if(campo6!=='XXX' && (!campo6 || campo6===campo6Sel)){
      argsAdd[campo6Val] = campo6Sel;
      errors.push({path: campo6Val, message: campo6Msg});
    }
    if(campo7!=='XXX' && (!campo7 || campo7===campo7Sel)){
      argsAdd[campo7Val] = campo7Sel;
      errors.push({path: campo7Val, message: campo7Msg});
    }
    if(campo8!=='XXX' && (!campo8 || campo8===campo8Sel)){
      argsAdd[campo8Val] = campo8Sel;
      errors.push({path: campo8Val, message: campo8Msg});
    }

    this.setState({argsAdd});
    this.setState({errorAdd: errors})
  }

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  permiteEstadosFalse = () => {
    Object.values(this.state).forEach((estado, i) => {
      if(estado===true && Object.getOwnPropertyNames(this.state)[i].substr(0, 7) === "permite"){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  nextVal = async (name) => {
    const argsUpd = {
        coleccion: name,
      }
      const response = await this.props.editSeqfindOneAndUpdate({
        variables: argsUpd
      });
      return response.data.editSeqfindOneAndUpdate.seq
 }

 ordenarArrayAsc = (array, campo) => {
  array.sort(function (a, b) {
    return a[campo] > b[campo];
  });
}

  showOS = async (ev) => {
    ev.preventDefault()
    // setTimeout(async ()=>{
    //   await this.props.allOdeS.refetch()
    // }, 1000)
    // await this.props.allOdeS.refetch()
    this.estadosFalse()
    this.setState({showOS: true})
  }

  lisSupInf = (ev, numOS) => {
    const lisSup = [];
    const lisSupIni = []
    let elemento2 = this.props.allOdeS.allOdeS?this.props.allOdeS.allOdeS:[]
// console.log(elemento2)
    elemento2 = elemento2.filter(elemento => elemento.numeroOS===numOS)
if(elemento2.length>0){
    elemento2.forEach((elemento3, _id) => {
      elemento3.recursos.forEach((elemento, _id) => {
        lisSup.push({_id: elemento._id, codigoTipoDoc: elemento.codigoTipoDoc,
          numeroDocum: elemento.numeroDocum, descrRecurso: elemento.descrRecurso, _idTipoRec: elemento.tiporec._id,
          descrTipoRec: elemento.tiporec.descrTipoRec, areaAprovech: elemento.tiporec.areaAprovech,
          estadoLis: true});

        lisSupIni.push({_id: elemento._id, codigoTipoDoc: elemento.codigoTipoDoc,
          numeroDocum: elemento.numeroDocum, descrRecurso: elemento.descrRecurso, _idTipoRec: elemento.tiporec._id,
          descrTipoRec: elemento.tiporec.descrTipoRec, areaAprovech: elemento.tiporec.areaAprovech,
          estadoLis: true});
      })
    })
  }else{
    // console.log(this.props.idLista)
    if(this.props.idLista.dirmayor.ciudades){
      if(this.props.idLista.dirmayor.ciudades.zonas.barrios.codigoTipoDocT){
        const elemento3 = this.props.allRecurso.allRecurso.filter(elemento =>
          elemento.codigoTipoDoc===this.props.idLista.dirmayor.ciudades.zonas.barrios.codigoTipoDocT&&
          elemento.numeroDocum===this.props.idLista.dirmayor.ciudades.zonas.barrios.numeroDocumT&&
          elemento.descrRecurso===this.props.idLista.dirmayor.ciudades.zonas.barrios.descrRecursoT)
          elemento3.forEach((elemento, _id) => {
            lisSup.push({_id: elemento._id, codigoTipoDoc: elemento.codigoTipoDoc,
              numeroDocum: elemento.numeroDocum, descrRecurso: elemento.descrRecurso, _idTipoRec: elemento.tiporec._id,
              descrTipoRec: elemento.tiporec.descrTipoRec, areaAprovech: elemento.tiporec.areaAprovech,
              estadoLis: true});
          })
      }
    }
  }
// console.log(lisSup)
// console.log(lisSupIni)

    this.ordenarArrayAsc(lisSup, 'descrRecurso')
    this.setState({lisSup})
    this.ordenarArrayAsc(lisSupIni, 'descrRecurso')
    this.setState({lisSupIni})

    const lisInf = [];
    const lisInfIni = [];
    elemento2 = this.props.allRecurso.allRecurso
    elemento2 = elemento2.filter(elemento => elemento.tiporec.areaAprovech==='TECNICA')
    if(this.props.codigoDptoUA!=="Todos..."){
      elemento2 = elemento2.filter(elemento => elemento.codigoDpto===this.props.codigoDptoUA||elemento.codigoDpto==="Todos...")
    }
    if(this.props.codigoCiudadUA!=="Todas..."){
      elemento2 = elemento2.filter(elemento => elemento.codigoCiudad===this.props.codigoCiudadUA||elemento.codigoCiudad==="Todas...")
    }
    elemento2.forEach((elemento, _id) => {
      let siExiste = false
      lisSup.forEach((elemento1, _id) => {
        if(elemento._id===elemento1._id){
          siExiste = true
        }
      })
      if(siExiste===false){
        lisInf.push({_id: elemento._id, codigoTipoDoc: elemento.codigoTipoDoc,
          numeroDocum: elemento.numeroDocum, descrRecurso: elemento.descrRecurso, _idTipoRec: elemento.tiporec._id,
          descrTipoRec: elemento.tiporec.descrTipoRec, areaAprovech: elemento.tiporec.areaAprovech,
          estadoLis: false});

        lisInfIni.push({_id: elemento._id, codigoTipoDoc: elemento.codigoTipoDoc,
          numeroDocum: elemento.numeroDocum, descrRecurso: elemento.descrRecurso, _idTipoRec: elemento.tiporec._id,
          descrTipoRec: elemento.tiporec.descrTipoRec, areaAprovech: elemento.tiporec.areaAprovech,
          estadoLis: false});
      }
    })
    this.ordenarArrayAsc(lisInf, 'descrRecurso')
    this.setState({lisInf})
    this.ordenarArrayAsc(lisInfIni, 'descrRecurso')
    this.setState({lisInfIni})
  }

  addOS = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    if(this.state.verOS){
      this.setState({verOS: true})
    }else{
      this.setState({addOS: true})
    }
    this.setState({errorAdd: []})
    this.lisSupInf(ev, "0")
  }

  handleChange = (ev, input)=>{
    // console.log(ev.target.value)
    // console.log(ev.target.name)
    const argsAdd = this.state.argsAdd
    if(ev.target.type==='checkbox'){
      argsAdd[ev.target.name] = ev.target.checked
    }else{
      // console.log("1111")
      argsAdd[ev.target.name] = ev.target.value
    }
  
    // const argsAdd = this.state.argsAdd
    // if(input.type==='checkbox'){
    //   argsAdd[input.name] = input.checked
    // }else{
    //   argsAdd[input.name] = input.value
    // }
    this.setState({argsAdd});
    // console.log(argsAdd)
  }

  actOdeS = async (argsUpd)=>{
      const response = await this.props.editOdeSUpdDoc({
        variables: argsUpd
      });
      const {errors, success} = response.data.editOdeSUpdDoc;
      if (!success){
        this.setState({errorAdd: errors})
      }
  }

  actCli = async (argsUpd)=>{
    const response = await this.props.editClienteUpdDoc({
      variables: argsUpd
    });
    const {errors, success} = response.data.editClienteUpdDoc;
    if (!success){
      this.setState({errorAdd: errors})
    }
  }

  actEqu = async (argsUpd)=>{
    const response = await this.props.editEquipo({
      variables: argsUpd
    });
    const {errors, success} = response.data.editEquipo;
    if (!success){
      this.setState({errorAdd: errors})
    }
  }

  handleQuitarDir = (ev, dirElim)=>{
    // console.log(dirElim)
    let numOS = this.state.idListaOS.numeroOS
    let argsDel
    argsDel = {
      "tipoAct": "EliminarDirmayor",
      "numeroOS": numOS,
      "_idDirmayor": dirElim._id,
    };
    this.actOdeS(argsDel)

    argsDel = {
      "tipoAct": "EliminarDireccion",
      "numeroOS": numOS,
      "descrTipoVia1": dirElim.descrTipoVia1,
    };
    this.actOdeS(argsDel)

    this.props.allOdeS.refetch()
    this.estadosFalse()
    this.setState({verOS: true})
  }

  handleQuitarTar = (ev, tarElim)=>{
    let numOS = this.state.idListaOS.numeroOS
    let argsDel
    argsDel = {
      "tipoAct": "EliminarTarifa",
      "numeroOS": numOS,
      "codigoTarifa": tarElim,
    };
    this.actOdeS(argsDel)

    this.props.allOdeS.refetch()
    this.estadosFalse()
    this.setState({verOS: true})
  }

  handleQuitarOf = (ev, ofElim)=>{
    let numOS = this.state.idListaOS.numeroOS
    let argsDel
    argsDel = {
      "tipoAct": "EliminarOferta",
      "numeroOS": numOS,
      "codigoOferta": ofElim,
    };
    this.actOdeS(argsDel)

    this.props.allOdeS.refetch()
    this.estadosFalse()
    this.setState({verOS: true})
  }

  handleQuitarEqu = (ev)=>{
    let numOS = this.state.idListaOS.numeroOS
    let argsDel
    argsDel = {
      "tipoAct": "EliminarEquipos",
      "numeroOS": numOS,
    };
    this.actOdeS(argsDel)

    this.props.allOdeS.refetch()
    this.estadosFalse()
    this.setState({verOS: true})
  }

  handleOS = async (ev, args, cliente, argsList, listServTar, listServOf, listEquiCliAsig,
    listEquiAsig, lisOferta, listTOS, fechaV, listServCargoFra, nuevaRenta, argsBod, estadoCi,
    fechaF, horaSolic, checkNoFactOsAb, updnoFactOSAb)=>{
    // console.log(listEquiCliAsig)
    // console.log(fechaV)
    // console.log(fechaF)
    // console.log(listServCargoFra)
    // console.log(listServTar)
    // console.log(listServOf)
    // console.log(lisOferta)
    // console.log(listTOS)
    // console.log(nuevaRenta)    
    // console.log(this.state.addOS)
    // console.log(this.state.permiteUpdate)
    // console.log(this.state.permiteDelete)
    // console.log(cliente)
    // console.log(this.state.permiteEqu)
    // console.log(args)
    // console.log(horaSolic)
    // console.log(fechaF, horaSolic, checkNoFactOsAb)
    let {data} = await this.props.allClientes2.refetch({contrato: cliente.contrato})
    // console.log(data.allClientes[0].saldoPendiente)
    let saldoCl = await data.allClientes[0].saldoPendiente

    let actFechas = []
    let argsUpdClFe = {
      "tipoAct": "EditarFechCli",
      "_id": cliente._id,
      "fechaUltOSAb": cliente.fechaUltOSAb,
      "fechaPrimeraActivacion": cliente.fechaPrimeraActivacion,
      "fechaUltDX": cliente.fechaUltDX,
      "fecgaUltRX": cliente.fecgaUltRX,
      "estadoAnterior": cliente.estadoAnterior,
      "fechaUltOSCe": cliente.fechaUltOSCe,
      "fechaUltPago": cliente.fechaUltPago,
      "valorUltPago": cliente.valorUltPago,
    }

    let updDir = []
    let servCF = []
    let servCFI = []
    let movCli = []
    let movCliI = []
    let servTarCli = []
    let servTarCliI = []
    let servOfCli = []
    let retEqCl = []
    let servEqCl = []
    // let servEqCl1 = []
    let eqNvos = []
    let elimEq = []
    let actCliente = []
    let actEstOS = []
    let actEstCl = []
    let actEstServCli = []
    let actCFCli = []

    let numDocCRUD = 0, totDocCRUD = 0, argsCrud = [], crudColecc = []

    // let totDocCRUD = 100

    //ACTUALIZAR BD
    async function crudBD(operacionCRUD, args, i) {
      // console.log("CRUD")
          if(args.ctrlCampo === 'CRUD'){
    // console.log(i)
    // console.log(args)
            const {data} = await operacionCRUD({
              variables: args
            });
      
      //Se utiliza para traer el _id del documento creado
            if(args.ctrl_id === 'SI_ID'){
              if(Object.values(data)[0]._id){
                return Object.values(data)[0]._id
              }else{
                return 0
              }
            }
          }else{
            if(args.ctrlCampo === "MANY"){
              // console.log("MANY")
              // console.log(args)
              await operacionCRUD({
                variables: args
              });
            }
          }
        }
      
      //ENVIO PARA ACTUALIZAR BD
        async function updColecc(crudColecc, argsCrud, totDocCRUD) {
    // console.log(argsCrud)
    // console.log(totDocCRUD)
          let codigo = 0
          // console.log(argsCrud)
          if(argsCrud[0].ctrl_id === 'SI_ID'){
            codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
          }else{
            await crudBD(crudColecc[0], argsCrud[0], 0)
          }
          if(codigo!==0){
            for(let i=1; i<totDocCRUD; i++){
              argsCrud[i]._id = codigo
            }
          }
    // console.log("inicio")
          for(let i=1; i<totDocCRUD; i++){
            await crudBD(crudColecc[i], argsCrud[i], i)
          }
    console.log("final")
        }

    async function asyncCall(promesas, callback) {
      try{
        let regActBD = await Promise.all(promesas)
//sin en el console.log no grabó todos los servicios => ?
        console.log(regActBD)
      }catch(i){
        console.log("error")
      }
      if(callback){
        callback()
      }
    }

    let argsUpd
    let argsDel
    let numOS = 0
    let opcWork = ""
//DIRECCION
// console.log("11", this.state)
    if(this.state.permiteDir){
      // console.log(this.state.argsAdd)
      opcWork = "Dir"
      if(!this.state.argsAdd.descrTipoVia1||this.state.argsAdd.descrTipoVia1==="Seleccionar..."||!this.state.argsAdd.numeroTipoVia1||
        !this.state.argsAdd.descrTipoVia2||this.state.argsAdd.descrTipoVia2==="Seleccionar..."||!this.state.argsAdd.numeroTipoVia2||
        !this.state.argsAdd.descrDpto||this.state.argsAdd.descrDpto==="Seleccionar..."||!this.state.argsAdd.nombreCiudad||this.state.argsAdd.nombreCiudad==="Seleccionar..."||
        !this.state.argsAdd.nombreZona||this.state.argsAdd.nombreZona==="Seleccionar..."||!this.state.argsAdd.nombreBarrio||this.state.argsAdd.nombreBarrio==="Seleccionar..."){
        // let sinCampo='XXX'
        this.validarHandle(this.state.argsAdd.descrTipoVia1, 'descrTipoVia1', 'Seleccionar...', 'Debe seleccionar la vía principal',
                          this.state.argsAdd.numeroTipoVia1, 'numeroTipoVia1', '', 'Debe escribir el número de la vía principal',
                          this.state.argsAdd.descrTipoVia2, 'descrTipoVia2', 'Seleccionar...', 'Debe escribir el número de la vía secundaria',
                          this.state.argsAdd.numeroTipoVia2, 'numeroTipoVia2', '', 'Debe escribir el número de la vía secundaria',
                          this.state.argsAdd.descrDpto, 'descrDpto', 'Seleccionar...', 'Debe seleccionar el departamento',
                          this.state.argsAdd.nombreCiudad, 'nombreCiudad', 'Seleccionar...', 'Debe seleccionar la ciudad',
                          this.state.argsAdd.nombreZona, 'nombreZona', 'Seleccionar...', 'Debe seleccionar la zona',
                          this.state.argsAdd.nombreBarrio, 'nombreBarrio', 'Seleccionar...', 'Debe seleccionar el barrio',)
      }else{
        const errors = [];
        // Validar si la Configuración de Idiomas en el navegador esta OK
        // console.log(this.props.allTipoVia.allTipoVia, this.state.argsAdd.descrTipoVia1, this.state.argsAdd.descrTipoVia2)
        
        if(this.props.empresa.empresaArchFE==="codisert"){
          if(!this.state.argsAdd.descrEstrato||this.state.argsAdd.descrEstrato==="Seleccionar..."){
          errors.push({path: 'descrEstrato', message: `Debe seleccionar el Estrato`});      
          }
        }
        
        let indexTV = await this.props.allTipoVia.allTipoVia.findIndex( tipovia => tipovia.descrTipoVia===this.state.argsAdd.descrTipoVia1 )
        if(indexTV===-1){
          errors.push({path: 'descrTipoVia1', message: `El tipo vía ${this.state.argsAdd.descrTipoVia1} no existe, por favor revise la configuración de Idiomas en el navegador (NO debe tener habilitada la traducción automática)`});      
        }
        indexTV = await this.props.allTipoVia.allTipoVia.findIndex( tipovia => tipovia.descrTipoVia===this.state.argsAdd.descrTipoVia2 )
        if(indexTV===-1){
          errors.push({path: 'descrTipoVia2', message: `El tipo vía ${this.state.argsAdd.descrTipoVia2} no existe, por favor revise la configuración de Idiomas en el navegador (NO debe tener habilitada la traducción automática)`});      
        }
        // FIN Validar si la Configuración de Idiomas en el navegador esta OK
        if(errors.length===0){
          // console.log(this.state.argsAdd)
          numOS = this.state.idListaOS.numeroOS
          argsUpd = {
            "ctrlCampo": "CRUD",
            "ctrl_id": "NO_ID",
            "accionBD": this.props.editOdeSUpdDoc,
            "tipoAct": "EditarDirmayor",
            "numeroOS": numOS,
            "_idDirmayor": this.state.argsAdd._id,
            "codigoDpto": this.state.argsAdd.codigoDpto,
            "descrDpto": this.state.argsAdd.descrDpto,
            "codigoDptoDANE": this.state.argsAdd.codigoDptoDANE,
            "codigoCiudad": this.state.argsAdd.codigoCiudad,
            "nombreCiudad": this.state.argsAdd.nombreCiudad,
            "codigoMunicipioDANE": this.state.argsAdd.codigoMunicipioDANE,
            "codigoPostalDANE": this.state.argsAdd.codigoPostalDANE,
            "codigoCiudadInterno": this.state.argsAdd.codigoCiudadInterno,
            "codBarrasRdo": this.state.argsAdd.codBarrasRdo,
            "codigoZona": this.state.argsAdd.codigoZona,
            "nombreZona": this.state.argsAdd.nombreZona,
            "codigoBarrio": this.state.argsAdd.codigoBarrio,
            "nombreBarrio": this.state.argsAdd.nombreBarrio,
            "codigoTipoDocT": this.state.argsAdd.codigoTipoDocT,
            "numeroDocumT": this.state.argsAdd.numeroDocumT,
            "descrRecursoT": this.state.argsAdd.descrRecursoT,
            "codigoTipoDocR": this.state.argsAdd.codigoTipoDocR,
            "numeroDocumR": this.state.argsAdd.numeroDocumR,
            "descrRecursoR": this.state.argsAdd.descrRecursoR,
          
            "descrTipoVia1": this.state.argsAdd.descrTipoVia1,
            "numeroTipoVia1": this.state.argsAdd.numeroTipoVia1,
            "descrTipoVia2": this.state.argsAdd.descrTipoVia2,
            "numeroTipoVia2": this.state.argsAdd.numeroTipoVia2,
            "numeroTipoVia2F": this.state.argsAdd.numeroTipoVia2F,
            "descrTipoUnd1": this.state.argsAdd.descrTipoUnd1,
            "numeroTipoUnd1": this.state.argsAdd.numeroTipoUnd1,
            "descrTipoUnd2": this.state.argsAdd.descrTipoUnd2,
            "numeroTipoUnd2": this.state.argsAdd.numeroTipoUnd2,
            "descrTiUndMat": this.state.argsAdd.descrTiUndMat,
            "descrUndMat": this.state.argsAdd.descrUndMat
          };
          if(this.props.empresa.empresaArchFE==="codisert"){
            argsUpd.descrEstrato = this.state.argsAdd.descrEstrato
          }
          if(!this.state.argsAdd.descrTipoUnd1){delete argsUpd.descrTipoUnd1}
          if(!this.state.argsAdd.numeroTipoUnd1){delete argsUpd.numeroTipoUnd1}
          if(!this.state.argsAdd.descrTipoUnd2){delete argsUpd.descrTipoUnd2}
          if(!this.state.argsAdd.numeroTipoUnd2){delete argsUpd.numeroTipoUnd2}
          if(!this.state.argsAdd.descrTiUndMat){delete argsUpd.descrTiUndMat}
          if(!this.state.argsAdd.descrUndMat){delete argsUpd.descrUndMat}
          // console.log(argsUpd)

          totDocCRUD = 1
          argsCrud = []
          argsCrud[0] = argsUpd
          argsCrud[0]['ctrlCampo'] = 'CRUD'
          argsCrud[0]['ctrl_id'] = 'NO_ID'
        
          crudColecc = []
          crudColecc[0] = this.props.editOdeSUpdDoc

          // console.log(crudColecc)
          // console.log(argsCrud)
          updColecc(crudColecc, argsCrud, totDocCRUD)

          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          await this.props.allOdeS.refetch({})
          this.estadosFalse()
          this.setState({verOS: true})
        }else{
          this.setState({errorAdd: errors})
        }
      }
  }
//FINALIZA DIRECCION
//TARIFA
// if((this.state.permiteTar||listTOS[0].permTarServ==="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS")&&
//   !this.state.addOS&&!this.state.permiteUpdate&&!this.state.permiteDelete){
if(this.state.permiteTar){
  // console.log(argsList)
  // console.log(listServTar)
  // console.log(fechaV)
  // console.log(listServTar.length)
  // console.log(listTOS[0].permTarServ)
  opcWork = "Tar"
  const errors = [];
  
  if(listServTar.length>5){
    errors.push({path: 'tarifa', message: `Tiene asignado ${listServTar.length} servicios (máximo permitido: 5)`});
  }

  if(listServTar.length===0&&listTOS[0].permTarServ!=="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"){
    errors.push({path: 'tarifa', message: `No hay servicios asignados en la tarifa`});
  }else{
    if(listServTar.length>0&&listTOS[0].permTarServ==="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"){
      errors.push({path: 'tarifa', message: `No puede asignar servicios a la tarifa`});
    }else{
      if(!fechaV){
        errors.push({path: 'tarifa', message: `Debe seleccionar la fecha de vencimiento de la tarifa`});
      }else{
        if(listServTar.length>0){
          if(this.props.comoAsigCicloFact==="Asignarlo a una tarifa y automáticamente al cliente cuando se le asigne tarifa"&&
          !listServTar[0].cicloFact){
            errors.push({path: 'tarifa', message: `La tarifa debe tener asignado el ciclo de facturación`});
          }
        }
        listServTar.forEach((elemento, _id) => {
          if(elemento.estadoSelecc===false){
            errors.push({path: 'tarifa', message: `El servicio ${elemento.nombreResumido} esta marcado para quitar, si desea quitarlo de la tarifa haga click en Refrescar`});
          }
          if(elemento.numeroServicios===null||elemento.numeroServicios===''||elemento.numeroServicios<=0){
            errors.push({path: 'tarifa', message: `El servicio ${elemento.nombreResumido} tiene un número de servicios inválido`});
          }
          if(elemento.valorServicios===null||elemento.valorServicios===''||elemento.valorServicios<0){
            errors.push({path: 'tarifa', message: `El servicio ${elemento.nombreResumido} tiene un valor inválido, verifique si el número de servicios tiene valor en la tarifa`});
          }
        })
      }
    }
  }

//validar que la tarifa a asignar tenga los mismos servicios e imptos que la coleccion tarifas
// console.log(listServTar)

  if(listServTar.length>0){
    let tarifaOS = this.props.allTarifa.allTarifa.filter(elemento => elemento.codigoTarifa===listServTar[0].codigoTarifa)
    listServTar.forEach((elemento, i) => {
      const indexSearch = tarifaOS[0].servicios.findIndex( servicio => servicio.codigoServicio===elemento.codigoServicio )
      tarifaOS[0].servicios[indexSearch].imptos.forEach((elemento1, i) => {
        const indexSearch = elemento.imptos.findIndex( impto => impto.codigoImpto===elemento1.codigoImpto )
        if(indexSearch===-1&&elemento1.codigoImpto){
          errors.push({path: 'impto', message: `El servicio ${elemento.descripcionServicio} no tiene el impuesto ${elemento1.descrImpto}`});      
        }
      })
    })
  }
// console.log(tarifaOS)
  this.setState({errorAdd: errors})
// console.log(errors)

  if(errors.length>0){
    this.setState({errorAdd: errors})
  }
  if(errors.length===0){
    numOS = this.state.idListaOS.numeroOS
//Crea o reemplaza la tarifa que este y agrega los servicios
    listServTar.forEach((elemento, i) => {
      argsUpd = {}
      argsUpd = {
        "tipoAct": i===0?"EditarTarifa":"EditarServTar",
        "numeroOS": numOS,
        "codigoTarifa": elemento.codigoTarifa,
        "descrTarifa": elemento.descrTarifa,
        "cicloFact": elemento.cicloFact?elemento.cicloFact:null,
        "fechaVence": fechaV,
        "codigoServicioT": elemento.codigoServicio,
        "nombreResumidoT": elemento.nombreResumido,
        "descripcionServicioT": elemento.descripcionServicio,
        "_idSubclaseServT": elemento._idSubclaseServ,
        "codigoSubclaseServT": elemento.codigoSubclaseServ,
        "descrSubclaseServT": elemento.descrSubclaseServ,
        "_idClaseServT": elemento._idClaseServ,
        "codigoClaseServT": elemento.codigoClaseServ,
        "descrClaseServT": elemento.descrClaseServ,
        "velEfecDownstream": elemento.velEfecDownstream,
        "velEfecUpstream": elemento.velEfecUpstream,
        "codigoTipoTec": elemento.codigoTipoTec,
        "descrTipoTec": elemento.descrTipoTec,
        "colorServicio": elemento.colorServicio,
        "estadoServicio": "A",
        "rango1NumServValorIni": elemento.rango1NumServValorIni,
        "rango1NumServValorFin": elemento.rango1NumServValorFin,
        "rango1Valor": elemento.rango1Valor,
        "rango2NumServValorIni": elemento.rango2NumServValorIni,
        "rango2NumServValorFin": elemento.rango2NumServValorFin,
        "rango2Valor": elemento.rango2Valor,
        "rango3NumServValorIni": elemento.rango3NumServValorIni,
        "rango3NumServValorFin": elemento.rango3NumServValorFin,
        "rango3Valor": elemento.rango3Valor,
        "numeroServicios": elemento.numeroServicios,
        "valorServicios": elemento.valorServicios,
        "valorAntesImptos": elemento.valorAntesImptos
      };
      servTarCli.push(argsUpd)
// console.log(argsUpd)
      elemento.imptos.forEach((elemento1, ii) => {
        if(elemento1.codigoImpto!==null){
          // console.log(elemento1)
          argsUpd = {}
          argsUpd = {
            "tipoAct": ii===0?"CrearImpto1":"CrearImpto2",
            "numeroOS": numOS,
            "codigoTarifa": elemento.codigoTarifa,
            "codigoServicioT": elemento.codigoServicio,
            "codigoImpto": elemento1.codigoImpto,
            "descrImpto": elemento1.descrImpto,
            "porcImpto": elemento1.porcImpto,
            "valorImpto": elemento1.valorImpto,
          }
          servTarCliI.push(argsUpd)
        }
      })
//       let crudColecc = []
//       for(let iii=0; iii<20; iii++){
//         crudColecc.push(this.props.editOdeSUpdDoc)
//       }
// // console.log(argsCrud)
//       updColecc(crudColecc, argsCrud, totDocCRUD)
    })
    // console.log(servTarCli)
    // console.log(servTarCliI)
    numDocCRUD = 0
    totDocCRUD = servTarCli.length + servTarCliI.length
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editOdeSUpdDoc)
    }
// console.log(totDocCRUD)
    servTarCli.forEach((elemento, i) => {
      // console.log(elemento)
      argsCrud[numDocCRUD] = elemento
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    
      // crudColecc[numDocCRUD] = this.props.editOdeSUpdDoc
    
      numDocCRUD += 1

      let imptosTC = servTarCliI.filter(imptos => imptos.codigoTarifa===elemento.codigoTarifa 
                                    && imptos.codigoServicioT===elemento.codigoServicioT)
      imptosTC.forEach((elemento1, ii) => {
        // console.log(elemento1)
        argsCrud[numDocCRUD] = elemento1
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    
        // crudColecc[numDocCRUD] = this.props.editClienteUpdDoc
    
        numDocCRUD += 1
      })
    })
    // console.log(crudColecc)
    // console.log(argsCrud, totDocCRUD)
    if(totDocCRUD>0){
      updColecc(crudColecc, argsCrud, totDocCRUD)
    }
    
    // console.log("listooo")
    this.setState({errorAdd: []})
    this.setState({argsAdd: {}})
    //retardar mientras graba los documentos y hacer refetch
    // setTimeout(()=>{
    //   this.props.allOdeS.refetch()
    // }, 1000)
    await this.props.allOdeS.refetch()
    this.estadosFalse()
    this.setState({verOS: true})
    // console.log("finalizo")
  }
}
//FINALIZA TARIFA

//OFERTA
if(this.state.permiteOfer){
  opcWork = "Ofe"
  const errors = [];
  if(listServOf.length===0){
    errors.push({path: 'oferta', message: `No se ha seleccionado una oferta válida`});
  }
  if(errors.length>0){
    this.setState({errorAdd: errors})
  }
  if(errors.length===0){
// console.log(listServOf)
    numOS = this.state.idListaOS.numeroOS
//Crea o reemplaza la tarifa que este y agrega los servicios
    listServOf.forEach((elemento, i) => {
      argsUpd = {
        "ctrlCampo": "CRUD",
        "ctrl_id": "NO_ID",
        "accionBD": this.props.editOdeSUpdDoc,
        "tipoAct": i===0?"EditarOferta":"EditarServOf",
        "numeroOS": numOS,
        "codigoOferta": elemento.codigoOferta,
        "descrOferta": elemento.descrOferta,
        "codigoServicioO": elemento.codigoServicio,
        "nombreResumidoO": elemento.nombreResumido,
        "descripcionServicioO": elemento.descripcionServicio,
        "_idSubclaseServO": elemento._idSubclaseServ,
        "codigoSubclaseServO": elemento.codigoSubclaseServ,
        "descrSubclaseServO": elemento.descrSubclaseServ,
        "_idClaseServO": elemento._idClaseServ,
        "codigoClaseServO": elemento.codigoClaseServ,
        "descrClaseServO": elemento.descrClaseServ,
        "porcDctoOferta": elemento.porcDctoOferta,
        "numDiasOferta": elemento.numDiasOferta,
        "fechaFinOferta": elemento.fechaFinOferta,
        "fechaInicioOferta": elemento.fechaInicioOferta
      };
//para manejarlo con array de promesas => para que se ejecuten todas y luego si vaya a imptos
      servOfCli.push(argsUpd)

      // console.log(argsUpd)
    })

//Agregar los servicios de la oferta
numDocCRUD = 0
totDocCRUD = servOfCli.length
argsCrud = []
crudColecc = []
for(let iii=0; iii<totDocCRUD; iii++){
  argsCrud.push({ctrlCampo: 'NO_CRUD'})
}
for(let iii=0; iii<totDocCRUD; iii++){
  crudColecc.push(this.props.editOdeSUpdDoc)
}
servOfCli.forEach((elemento, i) => {
  // console.log(elemento)
  argsCrud[numDocCRUD] = elemento
  argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

  numDocCRUD += 1
})
// console.log(crudColecc)
// console.log(argsCrud)
if(totDocCRUD>0){
  updColecc(crudColecc, argsCrud, totDocCRUD)
}

    this.setState({errorAdd: []})
    this.setState({argsAdd: {}})
    //retardar mientras graba los documentos y hacer refetch
    // setTimeout(()=>{
    //   this.props.allOdeS.refetch()
    // }, 1000)
    await this.props.allOdeS.refetch()
    this.estadosFalse()
    this.setState({verOS: true})
  }
}
//FINALIZA OFERTA

//EQUIPOS
// console.log(this.state.permiteEqu)
// console.log(listTOS[0].permEquipos)
// console.log(listEquiAsig)
// console.log(listEquiAsig.length)
if(this.state.permiteEqu||(listTOS[0].permEquipos==="RETIRAR TODOS"&&listEquiAsig.length>0&&!this.state.permiteUpdate)){
  opcWork = "Equ"
  const errors = [];
  if(errors.length>0){
    this.setState({errorAdd: errors})
  }
  if(errors.length===0){
    numOS = this.state.idListaOS.numeroOS

//Crea o reemplaza la tarifa que este y agrega los servicios
    let listaEquipos = listEquiCliAsig.concat(listEquiAsig)
    // console.log(listaEquipos)
    listaEquipos.forEach((elemento, i) => {
      let accion = ""
      const indexSearch = listEquiCliAsig.findIndex( serial => serial.numeroSerie === elemento.numeroSerie );
      if(indexSearch!==-1){
        const indexSearch = cliente.equipos.findIndex( serial => serial.numeroSerie === elemento.numeroSerie );
        if(indexSearch===-1){
          accion = "AGREGAR"
        }else{
          accion = "IGUAL"
        }
      }else{
        const indexSearch = cliente.equipos.findIndex( serial => serial.numeroSerie === elemento.numeroSerie );
        if(indexSearch!==-1){
          accion = "RETIRAR"
        }
      }
      if(accion !== ""){
        argsUpd = {
          "accionBD": this.props.editOdeSUpdDoc,
          "tipoAct": i===0?"EditarEquipo":"EditarEquiCl",
          "numeroOS": numOS,
          "numeroSerie": elemento.numeroSerie,
          "mac": elemento.mac,
          "accion": accion,
          "_idClaseEqu": elemento._idClaseEqu,
          "codigoClaseEqu": elemento.codigoClaseEqu,
          "descrClaseEqu": elemento.descrClaseEqu,
          "_idMarcaEqu": elemento._idMarcaEqu,
          "codigoMarcaEqu": elemento.codigoMarcaEqu,
          "descrMarcaEqu": elemento.descrMarcaEqu,
          "_idFabriEqu": elemento._idFabriEqu,
          "codigoFabriEqu": elemento.codigoFabriEqu,
          "descrFabriEqu": elemento.descrFabriEqu
        };
//para manejarlo con array de promesas => para que se ejecuten todas
      servEqCl.push(argsUpd)
        // console.log(argsUpd)
      }
    })
    // console.log(servEqCl)

    numDocCRUD = 0
    totDocCRUD = servEqCl.length
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editOdeSUpdDoc)
    }
    servEqCl.forEach((elemento, i) => {
      argsCrud[numDocCRUD] = elemento
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    
      numDocCRUD += 1
    })
    if(totDocCRUD>0){
      updColecc(crudColecc, argsCrud, totDocCRUD)
    }

    // console.log(this.state.permiteEqu)
    if(this.state.permiteEqu){
      this.setState({errorAdd: []})
      this.setState({argsAdd: {}})
      //retardar mientras graba los documentos y hacer refetch
      // setTimeout(()=>{
      //   this.props.allOdeS.refetch()
      // }, 1000)
      await this.props.allOdeS.refetch()
      this.estadosFalse()
      this.setState({verOS: true})
    }
  }
}
//FINALIZA EQUIPOS

//CERRAR O DE S
if(this.state.permiteClose){
    // console.log(listTOS[0].genOSDirAnt)
  // console.log("entro cerrar")
  opcWork = "Clo" 
  // console.log(this.props.allOdeS.allOdeS)
  // console.log(this.state.idListaOS.numeroOS)
  let odes = this.props.allOdeS.allOdeS.filter(elemento => elemento.numeroOS===this.state.idListaOS.numeroOS)
  odes = odes[0]
  // console.log(odes.genOSDirAnt)
  // console.log(args)
  // const odes = this.props.allOdeS.allOdeS[0]
  // console.log(odes)
  // console.log(listTOS[0])
  const errors = [];
  // console.log(odes.tarifa.codigoTarifa)
  // console.log(args.descrOtrosPagCl, args.stValor)
  if(args.descrOtrosPagCl==="Seleccionar..."&&args.stValor>0){
    errors.push({path: 'Nuevo cargo', message: `Por favor seleccione el Concepto del nuevo cargo a próxima factura`});
    let descrOtrosPagCl = document.getElementById("miListaCpto");
    descrOtrosPagCl.options.selectedIndex = 0
  }
  if(args.descrOtrosPagCl!=="Seleccionar..."&&args.stValor<=0){
    errors.push({path: 'Nuevo cargo', message: `Por favor escriba el valor para el Concepto del nuevo cargo a próxima factura`});
    let descrOtrosPagCl = document.getElementById("miListaCpto");
    descrOtrosPagCl.options.selectedIndex = 0
  }
  if((!args.codigoPaquete||!args.descrPaquete)&&odes.tarifa.codigoTarifa){
    errors.push({path: 'Paquete', message: `Por favor seleccione el paquete`});
  }
  if(cliente.estadoCliente==="NUEVO"&&!odes.dirmayor.codigoDpto&&listTOS[0].estadoCrearOS!=="CUALQUIERA"){
    errors.push({path: 'O de S', message: `La O de S ${odes.numeroOS} no tiene asignada dirección`});
  }
  
  // if((cliente.estadoCliente==="NUEVO"||cliente.estadoCliente==="DESCONECTADO")&&
  //   !odes.tarifa.codigoTarifa&&listTOS[0].permTarServ!=="DEJAR IGUAL"&&listTOS[0].estadoCerrarOS!=="DEJAR IGUAL"){
  //   errors.push({path: 'O de S', message: `La O de S ${odes.numeroOS} no tiene asignada tarifa`});
  // }
  if(((cliente.estadoCliente==="NUEVO"||cliente.estadoCliente==="DESCONECTADO")&&listTOS[0].estadoCrearOS!=="CUALQUIERA")&&
    !odes.tarifa.codigoTarifa&&listTOS[0].permTarServ!=="DEJAR IGUAL"&&listTOS[0].estadoCerrarOS!=="DEJAR IGUAL"&&
    args.estadoCierre==="ACTIVO"){
    errors.push({path: 'O de S', message: `La O de S ${odes.numeroOS} no tiene asignada tarifa`});
  }

  if(!args.observacCE){
    errors.push({path: 'O de S', message: `Por favor escriba la observación de cierre`});
  }

  // if((this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable")&&!args.codigoMarquilla.trim()){
  // if(this.props.empresa.empresaArchFE==="conectic"&&!args.codigoMarquilla.trim()){
  //   errors.push({path: 'O de S', message: `Por favor escriba la Marquilla`});
  // }

  if(!estadoCi||estadoCi==="Seleccionar..."){
    errors.push({path: 'O de S', message: `Por favor seleccione el nuevo estado del cliente`});
  }

  if(estadoCi!=="ACTIVO"&&cliente.estadoCliente!=="NUEVO"&&odes.tarifa.codigoTarifa){
    errors.push({path: 'O de S', message: `El cliente va a quedar ${estadoCi}, no puede asignar tarifa en la OS`});
  }
  if(estadoCi==="ACTIVO"&&!odes.tarifa.codigoTarifa&&cliente.estadoCliente!=="ACTIVO"){
    errors.push({path: 'O de S', message: `El cliente va a quedar ${estadoCi}, debe asignarle una tarifa`});
  }

  if(listTOS[0].permTarServ!=="DEJAR IGUAL"&&listTOS[0].permTarServ!=="CAMBIAR TARIFA"&&
        odes.tarifa.codigoTarifa!==cliente.tarifa.codigoTarifa&&
        listTOS[0].permTarServ!=="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"){
    errors.push({path: 'O de S', message: `El tipo de OS no permite cambiar la tarifa`});
  }
  if(listTOS[0].permTarServ==="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"&&odes.tarifa.codigoTarifa){
    errors.push({path: 'O de S', message: `El tipo de OS no permite asignar tarifa`});
  }
  if(listTOS[0].permTarServ==="IGUAL TARIFA - QUITAR UNO O VARIOS SERVICIOS"){
    listServCargoFra.forEach((elemento, i) => {
      if(elemento.numeroServicios>0){
        errors.push({path: 'O de S', message: `En O de S de ${listTOS[0].descrTipoOS} no se permite agregar servicios`});
      }
    })
  }
  // console.log(odes.direccion)
  if(listTOS[0].permDireccion==="CAMBIAR"&&(!odes.direccion||!odes.direccion.descrTipoVia1)){
    errors.push({path: 'O de S', message: `El tipo de OS requiere que asigne dirección`});
  }
  if(odes.tarifa.codigoTarifa){
    if(this.props.comoAsigCicloFact==="Asignarlo a una tarifa y automáticamente al cliente cuando se le asigne tarifa"&&
    !odes.tarifa.cicloFact){
      errors.push({path: 'tarifa', message: `La tarifa debe tener asignado el ciclo de facturación`});
    }
  }
  if(odes.tarifa&&odes.tarifa.servicios&&odes.tarifa.servicios.length>5){
    errors.push({path: 'tarifa', message: `Tiene asignado ${odes.tarifa.servicios.length} servicios (máximo permitido: 5)`});
  }

  //   if(listTOS[0].permTarServ!=="DEJAR IGUAL"&&listTOS[0].permTarServ!=="CAMBIAR TARIFA"){
  // console.log("rx")
  // console.log(listTOS[0].permTarServ)
  //     if(odes.tarifa.codigoTarifa===null&&listTOS[0].permTarServ!=="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"){
  // console.log("rx 1")
  //       errors.push({path: 'tarifa', message: `No se han realizado las modificaciones requeridas a los servicios de la tarifa`});
  //     }else{
  //       if(listTOS[0].permTarServ!=="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"&&
  //       cliente.estadoCliente!=="DESCONECTADO"&&cliente.estadoCliente!=="NUEVO"){
  //           if(odes.tarifa.servicios.length===cliente.tarifa.servicios.length&&
  //           listTOS[0].permTarServ==="IGUAL TARIFA - QUITAR UNO O VARIOS SERVICIOS"){
  //             errors.push({path: 'tarifa', message: `No se han realizado las modificaciones requeridas a los servicios de la tarifa (quitar uno o varios servicios)`});
  //         }
  //       }
  //     }
  //   }

  // console.log(argsBod)
  // console.log(listEquiAsig)
  listEquiAsig.forEach((elemento, i) => {
    if(errors.length===0){
      const indexSearch = cliente.equipos.findIndex( serial => serial.numeroSerie === elemento.numeroSerie );
      if(indexSearch!==-1){
        if(!argsBod.descrBodega||argsBod.descrBodega==="Seleccionar..."){
          errors.push({path: 'Bodega', message: "Debe seleccionar la bodega donde se van a aingresar los equipos retirados"});
        }
      }
    }
  })

  if(errors.length>0){
    this.setState({errorAdd: errors})
  }
  if(errors.length===0){
    // let fechaHoy = new Date()
    // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha
    let fechaHoy = fechaHoraHoy.substr(0, 10)
    let horaHoy = fechaHoraHoy.substr(11, 8)

    //CREA REGISTRO EN HISTCLIENTES
    let updDoc = []
    let argsAddHC = {
      "fechaHistCliente": fechaHoy + ' ' + horaHoy,
      "contrato": cliente.contrato,
      "movimiento": "OS",
      "descripcion": "Orden de Servicio",
      "detalle": listTOS[0].descrTipoOS,
      "relacion": odes.numeroOS.toString(),
      "valor": 0,
      "usuarioCreate": sessionStorage.getItem('userLogin'),
    }
    updDoc.push(argsAddHC)

    const _idCli = cliente._id
    numOS = odes.numeroOS
    // let saldoCl = cliente.saldoPendiente

    // console.log(_idCli)
    // console.log(numOS)
    // console.log(odes.dirmayor.codigoDpto, odes.osQueLaGenero)
    if(odes.dirmayor.codigoDpto&&!odes.osQueLaGenero){
      // console.log(odes.dirmayor)
      let descrEstrato = ""
      if(this.props.empresa.empresaArchFE==="codisert"){
        // console.log(odes.descrEstrato)
        if(odes.descrEstrato){
          descrEstrato = odes.descrEstrato
        }
      }
      argsUpd = {
        "accionBD": this.props.editClienteUpdDoc,
        "tipoAct": "EditarDirmayor",
        "_id": _idCli,
        "descrEstrato": descrEstrato,
        "codigoDpto": odes.dirmayor.codigoDpto,
        "descrDpto": odes.dirmayor.descrDpto,
        "codigoDptoDANE": odes.dirmayor.codigoDptoDANE,
        "codigoCiudad": odes.dirmayor.ciudades.codigoCiudad,
        "nombreCiudad": odes.dirmayor.ciudades.nombreCiudad,
        "codigoMunicipioDANE": odes.dirmayor.ciudades.codigoMunicipioDANE,
        "codigoPostalDANE": odes.dirmayor.ciudades.codigoPostalDANE,
        "codigoCiudadInterno": odes.dirmayor.ciudades.codigoCiudadInterno,
        "codBarrasRdo": odes.dirmayor.ciudades.codBarrasRdo,
        "codigoZona": odes.dirmayor.ciudades.zonas.codigoZona,
        "nombreZona": odes.dirmayor.ciudades.zonas.nombreZona,
        "codigoBarrio": odes.dirmayor.ciudades.zonas.barrios.codigoBarrio,
        "nombreBarrio": odes.dirmayor.ciudades.zonas.barrios.nombreBarrio,
        "codigoTipoDocT": odes.dirmayor.ciudades.zonas.barrios.codigoTipoDocT,
        "numeroDocumT": odes.dirmayor.ciudades.zonas.barrios.numeroDocumT,
        "descrRecursoT": odes.dirmayor.ciudades.zonas.barrios.descrRecursoT,
        "codigoTipoDocR": odes.dirmayor.ciudades.zonas.barrios.codigoTipoDocR,
        "numeroDocumR": odes.dirmayor.ciudades.zonas.barrios.numeroDocumR,
        "descrRecursoR": odes.dirmayor.ciudades.zonas.barrios.descrRecursoR,

        "descrTipoVia1": odes.direccion.descrTipoVia1,
        "numeroTipoVia1": odes.direccion.numeroTipoVia1,
        "descrTipoVia2": odes.direccion.descrTipoVia2,
        "numeroTipoVia2": odes.direccion.numeroTipoVia2,
        "numeroTipoVia2F": odes.direccion.numeroTipoVia2F,
        "descrTipoUnd1": odes.direccion.descrTipoUnd1,
        "numeroTipoUnd1": odes.direccion.numeroTipoUnd1,
        "descrTipoUnd2": odes.direccion.descrTipoUnd2,
        "numeroTipoUnd2": odes.direccion.numeroTipoUnd2,
        "descrTiUndMat": odes.direccion.descrTiUndMat,
        "descrUndMat": odes.direccion.descrUndMat
      };
      if(!odes.direccion.descrTipoUnd1){delete argsUpd.descrTipoUnd1}
      if(!odes.direccion.numeroTipoUnd1){delete argsUpd.numeroTipoUnd1}
      if(!odes.direccion.descrTipoUnd2){delete argsUpd.descrTipoUnd2}
      if(!odes.direccion.numeroTipoUnd2){delete argsUpd.numeroTipoUnd2}
      if(!odes.direccion.descrTiUndMat){delete argsUpd.descrTiUndMat}
      if(!odes.direccion.descrUndMat){delete argsUpd.descrUndMat}

      updDir.push(argsUpd)
      // this.actCli(argsUpd)

      let linea1DNN = `${odes.direccion.descrTipoVia1?odes.direccion.descrTipoVia1:""}${odes.direccion.numeroTipoVia1?" " + odes.direccion.numeroTipoVia1:""}`
      linea1DNN += `${odes.direccion.descrTipoVia2?" " + odes.direccion.descrTipoVia2:""}${odes.direccion.numeroTipoVia2?" " + odes.direccion.numeroTipoVia2:""}`
      linea1DNN += `${odes.direccion.numeroTipoVia2F?" " + odes.direccion.numeroTipoVia2F:""}${odes.direccion.descrTipoUnd1?" " + odes.direccion.descrTipoUnd1:""}`
      linea1DNN += `${odes.direccion.numeroTipoUnd1?" " + odes.direccion.numeroTipoUnd1:""}${odes.direccion.descrTipoUnd2?" " + odes.direccion.descrTipoUnd2:""}`
      linea1DNN += `${odes.direccion.numeroTipoUnd2?" " + odes.direccion.numeroTipoUnd2:""}${odes.direccion.descrTiUndMat?" " + odes.direccion.descrTiUndMat:""}`
      linea1DNN += `${odes.direccion.descrUndMat?" " + odes.direccion.descrUndMat:""}`

      let linea3DNN = `${odes.dirmayor.ciudades.nombreCiudad?odes.dirmayor.ciudades.nombreCiudad:""}`    
      let linea4DNN = `${odes.dirmayor.ciudades.zonas.nombreZona?", " + odes.dirmayor.ciudades.zonas.nombreZona:""}`
      linea4DNN += `${odes.dirmayor.ciudades.zonas.barrios.nombreBarrio?", " + odes.dirmayor.ciudades.zonas.barrios.nombreBarrio:""}`
      // console.log(linea1DNN)
      // console.log(linea3DNN)
      // console.log(linea4DNN)
      // console.log(`${linea1DNN} - ${linea3DNN} ${linea4DNN}`)

      let linea1DAnt = ""
      let linea3DAnt = ""
      let linea4DAnt = ""
      if(cliente.estadoCliente!=="NUEVO"){
        linea1DAnt = `${cliente.direccion.descrTipoVia1?cliente.direccion.descrTipoVia1:""}${cliente.direccion.numeroTipoVia1?" " + cliente.direccion.numeroTipoVia1:""}`
        linea1DAnt += `${cliente.direccion.descrTipoVia2?" " + cliente.direccion.descrTipoVia2:""}${cliente.direccion.numeroTipoVia2?" " + cliente.direccion.numeroTipoVia2:""}`
        linea1DAnt += `${cliente.direccion.numeroTipoVia2F?" " + cliente.direccion.numeroTipoVia2F:""}${cliente.direccion.descrTipoUnd1?" " + cliente.direccion.descrTipoUnd1:""}`
        linea1DAnt += `${cliente.direccion.numeroTipoUnd1?" " + cliente.direccion.numeroTipoUnd1:""}${cliente.direccion.descrTipoUnd2?" " + cliente.direccion.descrTipoUnd2:""}`
        linea1DAnt += `${cliente.direccion.numeroTipoUnd2?" " + cliente.direccion.numeroTipoUnd2:""}${cliente.direccion.descrTiUndMat?" " + cliente.direccion.descrTiUndMat:""}`
        linea1DAnt += `${cliente.direccion.descrUndMat?" " + cliente.direccion.descrUndMat:""}`

        linea3DAnt = `${cliente.dirmayor.ciudades.nombreCiudad?cliente.dirmayor.ciudades.nombreCiudad:""}`    
        linea4DAnt = `${cliente.dirmayor.ciudades.zonas.nombreZona?", " + cliente.dirmayor.ciudades.zonas.nombreZona:""}`
        linea4DAnt += `${cliente.dirmayor.ciudades.zonas.barrios.nombreBarrio?", " + cliente.dirmayor.ciudades.zonas.barrios.nombreBarrio:""}`

        argsAddHC = {
          "fechaHistCliente": fechaHoy + ' ' + horaHoy,
          "contrato": cliente.contrato,
          "movimiento": "OS",
          "descripcion": `Dir Ant: ${linea1DAnt} - ${linea3DAnt} ${linea4DAnt}`,
          "detalle": `Dir nueva: ${linea1DNN} - ${linea3DNN} ${linea4DNN}`,
          "relacion": odes.numeroOS.toString(),
          "valor": 0,
          "usuarioCreate": sessionStorage.getItem('userLogin'),
        }
        updDoc.push(argsAddHC)
      }
    }

    // console.log(listServCargoFra)
    //GRABAR CARGOS EN OS
    let valorPagNeg = 0
    if(odes.tarifa.codigoTarifa||listServCargoFra.length>0||
      listTOS[0].permTarServ==="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"){
      // console.log("entro CF OS")
      listServCargoFra.forEach((elemento, i) => {
        argsUpd = {
          "accionBD": this.props.editOdeSUpdDoc,
          "tipoAct": i===0?"EditarCargoFra":"EditarServCF",
          "numeroOS": numOS,
          "descrClaseServ": elemento.descrClaseServ,
          "codigoServicio": elemento.codigoServicio,
          "nombreResumido": elemento.nombreResumido,
          "descripcionServicio": elemento.descripcionServicio,
          "fechaCargo": elemento.fechaCargo,
          "periodoFrado": elemento.periodoFrado,
          "origen": "OS-" + numOS,
          "numeroServiciosCF": elemento.numeroServicios,
          "valorTotal": elemento.valorServicios,
          "valorAntesImptosCF": elemento.valorAntesImptos,
          "agnoFra": elemento.agnoFra,
          "mesFra": elemento.mesFra,
        };
        // this.actOdeS(argsUpd)
        //para manejarlo con array de promesas => para que se ejecuten todas y luego si vaya a imptos
        servCF.push(argsUpd)
        // console.log(argsUpd)
      })
      // console.log(this.props.comoAsigCargosAlCliente)
      // console.log(saldoCl, listServCargoFra)
      let saldoClCC = saldoCl

      //verificar si el valor total a descontar (neg) es mayor que el saldocl, si es asi, la dif se cruza con
      //los cargos positivos
      let totCargosHC = 0
      listServCargoFra.forEach((elemento, i) => {
        totCargosHC += elemento.valorServicios
        if(elemento.valorServicios<0){
          valorPagNeg += elemento.valorServicios
        }
      })
      let difSaldoNeg = 0
      if(saldoCl<(valorPagNeg * -1)){
        difSaldoNeg = (valorPagNeg * -1) - saldoCl
      }

      if(totCargosHC!==0){
        argsAddHC = {
          "fechaHistCliente": fechaHoy + ' ' + horaHoy,
          "contrato": cliente.contrato,
          "movimiento": "OS",
          "descripcion": "Cargos por OS",
          "detalle": listTOS[0].descrTipoOS,
          "relacion": odes.numeroOS.toString(),
          "valor": totCargosHC,
          "usuarioCreate": sessionStorage.getItem('userLogin'),
        }
        updDoc.push(argsAddHC)
      }

      //CREA REGISTROS EN movclientes
      listServCargoFra.forEach((elemento, i) => {
        movCliI = []
        elemento.imptos.forEach((elemento1, ii) => {
          if(elemento1.codigoImpto!==null){
            argsUpd = {
              // "tipoAct": ii===0?"CrearImptoMC1":"CrearImptoMC2",
              // "origen": "OS-" + numOS,
              // "codigoServicio": elemento.codigoServicio,
              "codigoImpto": elemento1.codigoImpto,
              "descrImpto": elemento1.descrImpto,
              "porcImpto": elemento1.porcImpto,
              "valorImpto": elemento1.valorImpto,
            }
          // console.log(argsUpd)
            movCliI.push(argsUpd)
          }
        })

        let valorPag = 0

        if(difSaldoNeg>0&&elemento.valorServicios>0){
          if(difSaldoNeg-elemento.valorServicios>=0){
            valorPag = elemento.valorServicios
          }else{
            valorPag = difSaldoNeg
          }
          difSaldoNeg -= valorPag
        }

        if(saldoCl<0&&elemento.valorServicios>0){
          if(saldoCl+elemento.valorServicios>0){
            valorPag = saldoCl * -1
          }else{
            valorPag = elemento.valorServicios
          }
        }
        saldoCl += elemento.valorServicios

        if(elemento.valorServicios<0){
          // valorPagNeg += elemento.valorServicios
          valorPag = elemento.valorServicios
        }

        argsUpd = {
          // "numeroOS": numOS,
          "contrato": cliente.contrato,
          "fechaMov": elemento.fechaCargo,
          "tipo": "C",
          "subTipo": "OC",
          "procesado": elemento.valorServicios===0?"S":"N",
          "codigoServicio": elemento.codigoServicio,
          "nombreResumido": elemento.nombreResumido,
          "descripcionServicio": elemento.descripcionServicio,
          "descrClaseServ": elemento.descrClaseServ,
          "velEfecDownstream": elemento.velEfecDownstream,
          "velEfecUpstream": elemento.velEfecUpstream,
          "codigoTipoTec": elemento.codigoTipoTec,
          "descrTipoTec": elemento.descrTipoTec,
          // "colorServicio": elemento.colorServicio,
          "periodo": elemento.periodoFrado,
          "origen": "OS-" + numOS + "=>" + listTOS[0].descrTipoOS,
          "saldoCliente": saldoCl,
          "valorTotal": elemento.valorServicios,
          "valorAntesImptos": elemento.valorAntesImptos,
          "agno": elemento.agnoFra,
          "mes": elemento.mesFra,
          "valorPagado": valorPag,
          "numeroOdeDX": 0,
          "usuarioCreate": sessionStorage.getItem('userLogin'),
          "imptos": movCliI,
        };
        // this.actOdeS(argsUpd)
        // console.log(argsUpd)
        //para manejarlo con array de promesas => para que se ejecuten todas y luego si vaya a imptos
        movCli.push(argsUpd)
      })
      if(this.props.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
        saldoCl = saldoClCC
      }
      // console.log(saldoCl)
      //Crea o reemplaza en clientes la tarifa que este y agrega los servicios
      //si es quitar todos los servicios => deja la tarifa en el cliente para despues rx lo mismo
      servTarCli = []
      servTarCliI = []
      let odesTar = []
      let odesCodTar = ""
      let odesDescrTar = ""
      let odesCicloFact = ""
      let fechaV = null
      let odesTarServ = []
      // console.log(odes)
      if(odes.tarifa.codigoTarifa){
        odesTar = odes.tarifa
        odesCodTar = odesTar.codigoTarifa
        odesDescrTar = odesTar.descrTarifa
        if(this.props.comoAsigCicloFact==="Asignarlo a una tarifa y automáticamente al cliente cuando se le asigne tarifa"&&
          odesTar.cicloFact){
            odesCicloFact = odesTar.cicloFact
          }
        fechaV = odesTar.fechaVence
        odesTarServ = odesTar.servicios

        argsAddHC = {
          "fechaHistCliente": fechaHoy + ' ' + horaHoy,
          "contrato": cliente.contrato,
          "movimiento": "OS",
          "descripcion": `Tarifa: ${odesTar.codigoTarifa} ${odesTar.descrTarifa}`,
          "detalle": `Renta mensual: ${nuevaRenta} - Vence: ${odesTar.fechaVence}`,
          "relacion": odes.numeroOS.toString(),
          "valor": 0,
          "usuarioCreate": sessionStorage.getItem('userLogin'),
        }
        updDoc.push(argsAddHC)
      }
      // console.log(odesTarServ)
      // console.log(_idCli)
      odesTarServ.forEach((elemento, i) => {
        argsUpd = {
          "accionBD": this.props.editClienteUpdDoc,
          "tipoAct": i===0?"EditarTarifa":"EditarServTar",
          "_id": _idCli,
          "codigoTarifa": odesCodTar,
          "descrTarifa": odesDescrTar,
          "fechaVence": fechaV,
          "codigoServicioT": elemento.codigoServicio,
          "nombreResumidoT": elemento.nombreResumido,
          "descripcionServicioT": elemento.descripcionServicio,
          "_idSubclaseServT": elemento.subclaseserv._id,
          "codigoSubclaseServT": elemento.subclaseserv.codigoSubclaseServ,
          "descrSubclaseServT": elemento.subclaseserv.descrSubclaseServ,
          "_idClaseServT": elemento.subclaseserv.claseserv._id,
          "codigoClaseServT": elemento.subclaseserv.claseserv.codigoClaseServ,
          "descrClaseServT": elemento.subclaseserv.claseserv.descrClaseServ,
          "velEfecDownstream": elemento.velEfecDownstream,
          "velEfecUpstream": elemento.velEfecUpstream,
          "codigoTipoTec": elemento.codigoTipoTec,
          "descrTipoTec": elemento.descrTipoTec,
          "colorServicio": elemento.colorServicio,
          "estadoServicio": "A",
          "rango1NumServValorIni": elemento.rango1NumServValorIni,
          "rango1NumServValorFin": elemento.rango1NumServValorFin,
          "rango1Valor": elemento.rango1Valor,
          "rango2NumServValorIni": elemento.rango2NumServValorIni,
          "rango2NumServValorFin": elemento.rango2NumServValorFin,
          "rango2Valor": elemento.rango2Valor,
          "rango3NumServValorIni": elemento.rango3NumServValorIni,
          "rango3NumServValorFin": elemento.rango3NumServValorFin,
          "rango3Valor": elemento.rango3Valor,
          "numeroServicios": elemento.numeroServicios,
          "valorServicios": elemento.valorServicios,
          "valorAntesImptos": elemento.valorAntesImptos
        };
      //para manejarlo con array de promesas => para que se ejecuten todas y luego si vaya a imptos
        servTarCli.push(argsUpd)
        // console.log(argsUpd)
      })

      if(odesTarServ.length>0){
        argsUpd = {}
        argsUpd = {
          "tipoAct": "EditarCliDX",
          "contrato": cliente.contrato,
          "numeroOdeDX": 0,
        }
        actEstServCli.push(argsUpd)
      }
      if(odesCicloFact){
        argsUpd = {}
        argsUpd = {
          "tipoAct": "EditarCliCF",
          "contrato": cliente.contrato,
          "cicloFact": odesCicloFact,
        }
        actCFCli.push(argsUpd)
      }

      //crea imptos en cargoFra de la O de S
      // console.log("imptos")
      argsUpd = {}
      listServCargoFra.forEach((elemento, i) => {
        elemento.imptos.forEach((elemento1, ii) => {
          if(elemento1.codigoImpto!==null){
            // console.log(elemento1)
            argsUpd = {
              "accionBD": this.props.editOdeSUpdDoc,
              "tipoAct": ii===0?"CrearImptoCF1":"CrearImptoCF2",
              "numeroOS": numOS,
              "codigoServicio": elemento.codigoServicio,
              "codigoImptoCF": elemento1.codigoImpto,
              "descrImptoCF": elemento1.descrImpto,
              "porcImptoCF": elemento1.porcImpto,
              "valorImptoCF": elemento1.valorImpto,
            }
            // console.log(argsUpd)
            servCFI.push(argsUpd)
            // this.actOdeS(argsUpd)
          }
        })
      })

      //crea imptos en movclientes
      // console.log("imptos")
      //       argsUpd = {}
      //       listServCargoFra.forEach((elemento, i) => {
      //         elemento.imptos.forEach((elemento1, ii) => {
      //           if(elemento1.codigoImpto!==null){
      //             argsUpd = {
      //               "tipoAct": ii===0?"CrearImptoMC1":"CrearImptoMC2",
      //               "origen": "OS-" + numOS,
      //               "codigoServicio": elemento.codigoServicio,
      //               "codigoImpto": elemento1.codigoImpto,
      //               "descrImpto": elemento1.descrImpto,
      //               "porcImpto": elemento1.porcImpto,
      //               "valorImpto": elemento1.valorImpto,
      //             }
      // // console.log(argsUpd)
      //             movCliI.push(argsUpd)
      //           }
      //         })
      //       })
      // console.log(movCliI)

      //Agrega imptos a la tarifa en clientes
      argsUpd = {}
      odesTarServ.forEach((elemento, i) => {
        elemento.imptos.forEach((elemento1, ii) => {
          if(elemento1.codigoImpto!==null){
            argsUpd = {
              "accionBD": this.props.editClienteUpdDoc,
              "tipoAct": ii===0?"CrearImpto1":"CrearImpto2",
              "_id": _idCli,
              "codigoTarifa": odesCodTar,
              "codigoServicioT": elemento.codigoServicio,
              "codigoImpto": elemento1.codigoImpto,
              "descrImpto": elemento1.descrImpto,
              "porcImpto": elemento1.porcImpto,
              "valorImpto": elemento1.valorImpto,
            }
            servTarCliI.push(argsUpd)
            // this.actCli(argsUpd)
          }
        })
      })
      // console.log(servTarCliI)
    }else{
      if(listTOS[0].permTarServ==="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"){
        // console.log("EditarTarifa ?")
        //Se deja la tarifa con los servicios para cuando se RX
        //Si hay que quitar los servicios => quitar comentarios de las siguientes lineas
        // argsUpd = {
        //   "accionBD": this.props.editClienteUpdDoc,
        //   "tipoAct": "EditarTarifa",
        //   "_id": cliente._id,
        //   "codigoTarifa": cliente.tarifa.codigoTarifa,
        //   "descrTarifa": cliente.tarifa.descrTarifa,
        // };
        // actCliente.push(argsUpd)
      }
    }
    // console.log(lisOferta)
    //Actualizar oferta en clientes
    if(lisOferta.length>0){
      let codOfHC = ""
      let descrOfHC = ""
      let fecIniOfHC = ""
      lisOferta.forEach((elemento, i) => {
        codOfHC = elemento.codigoOferta
        descrOfHC = elemento.descrOferta
        fecIniOfHC = elemento.fechaInicioOferta
        argsUpd = {
          "accionBD": this.props.editClienteUpdDoc,
          "tipoAct": i===0?"EditarOferta":"EditarServOf",
          "_id": _idCli,
          "codigoOferta": elemento.codigoOferta,
          "descrOferta": elemento.descrOferta,
          "codigoServicioO": elemento.codigoServicio,
          "nombreResumidoO": elemento.nombreResumido,
          "descripcionServicioO": elemento.descripcionServicio,
          "_idSubclaseServO": elemento._idSubclaseServ,
          "codigoSubclaseServO": elemento.codigoSubclaseServ,
          "descrSubclaseServO": elemento.descrSubclaseServ,
          "_idClaseServO": elemento._idClaseServ,
          "codigoClaseServO": elemento.codigoClaseServ,
          "descrClaseServO": elemento.descrClaseServ,
          "porcDctoOferta": elemento.porcDctoOferta,
          "numDiasOferta": elemento.numDiasOferta,
          "fechaFinOferta": elemento.fechaFinOferta,
          "fechaInicioOferta": elemento.fechaInicioOferta
        };
      //para manejarlo con array de promesas => para que se ejecuten todas y luego si vaya a imptos
      servOfCli.push(argsUpd)
      // console.log(argsUpd)

      argsAddHC = {
        "fechaHistCliente": fechaHoy + ' ' + horaHoy,
        "contrato": cliente.contrato,
        "movimiento": "OS",
        "descripcion": `Oferta: ${codOfHC} ${descrOfHC}`,
        "detalle": `Inicia en: ${fecIniOfHC}`,
        "relacion": odes.numeroOS.toString(),
        "valor": 0,
        "usuarioCreate": sessionStorage.getItem('userLogin'),
        }
        updDoc.push(argsAddHC)
      })
      // console.log(servOfCli)
    }
    // console.log(odes)
    // console.log(listTOS[0].permEquipos)
    //Actualizar equipos en clientes
    if(odes.equipos.length>0||listTOS[0].permEquipos==="RETIRAR TODOS"){
      let retiraTodo = true

      listEquiAsig.forEach((elemento, i) => {
        const indexSearch = cliente.equipos.findIndex( serial => serial.numeroSerie === elemento.numeroSerie );
        if(indexSearch!==-1){
        //Actualizar el estado y la bodega del equipo
        // console.log(argsBod)
        // console.log(elemento)
          let argsUpdEq = {
            "accionBD": this.props.editEquipo,
            "tipoAct": "EstadoBodega",
            "numeroSerie": elemento.numeroSerie,
            "estadoEquipo": "BODEGA",
            "_idBodega": argsBod._idBodega,
            "codigoBodega": argsBod.codigoBodega,
            "descrBodega": argsBod.descrBodega
          };
        //para manejarlo con array de promesas => para que se ejecuten todas
          retEqCl.push(argsUpdEq)
          // console.log(argsUpdEq)
        }
      })

      if(listTOS[0].permEquipos!=="RETIRAR TODOS"){
        odes.equipos.forEach((elemento, i) => {
          if(elemento.accion!=="RETIRAR"){
            retiraTodo = false
            argsUpd = {
              "accionBD": this.props.editClienteUpdDoc,
              "tipoAct": i===0?"EditarEquipo":"EditarEquiCl",
              "_id": _idCli,
              "numeroSerie": elemento.numeroSerie,
              "mac": elemento.mac,
              "_idClaseEqu": elemento.claseequ._id,
              "codigoClaseEqu": elemento.claseequ.codigoClaseEqu,
              "descrClaseEqu": elemento.claseequ.descrClaseEqu,
              "_idMarcaEqu": elemento.marcaequ._id,
              "codigoMarcaEqu": elemento.marcaequ.codigoMarcaEqu,
              "descrMarcaEqu": elemento.marcaequ.descrMarcaEqu,
              "_idFabriEqu": elemento.fabriequ._id,
              "codigoFabriEqu": elemento.fabriequ.codigoFabriEqu,
              "descrFabriEqu": elemento.fabriequ.descrFabriEqu
            };
            //para manejarlo con array de promesas => para que se ejecuten todas
            servEqCl.push(argsUpd)
            // console.log(argsUpd)

            if(elemento.accion==="AGREGAR"){
              let argsUpdEq = {
                "accionBD": this.props.editEquipo,
                "tipoAct": "EstadoCliente",
                "numeroSerie": elemento.numeroSerie,
                "mac": elemento.mac,
                "estadoEquipo": "CLIENTE",
                "contrato": cliente.contrato
              };
              //para manejarlo con array de promesas => para que se ejecuten todas
              eqNvos.push(argsUpdEq)
              // console.log(argsUpdEq)
            }
          }
        })
        // console.log(servEqCl)
        // console.log(eqNvos)
      }

      if(retiraTodo===true){
        argsUpd = {
          "accionBD": this.props.editClienteUpdDoc,
          "tipoAct": "EliminarEquipos",
          "_id": _idCli,
        };
        elimEq.push(argsUpd)
        // this.actCli(argsUpd)
      }
    }

    // console.log(odes)
    // console.log(args)
    //Actualizar O de S
    argsUpd = {
      "accionBD": this.props.editOdeS,
      "numeroOS": numOS,
      "estadoOS": "CERRADA",
      "impresa": odes.impresa,
      "ptosAdic": odes.ptosAdic,
      "descrCategOST": odes.descrCategOST,
      "observacAB": odes.observacAB,
      "observacCE": args.observacCE,
      "observacCA": args.observacCA,
      "codigoMarquilla": args.codigoMarquilla,
      "descrClasifOST": args.descrClasifOST,
      "descrNodo": args.descrNodo?args.descrNodo:"",
      "codigoPaquete": args.codigoPaquete,
      "descrPaquete": args.descrPaquete,
      "codigoTipoDocV": args.codigoTipoDocV,
      "numeroDocumV": args.numeroDocumV,
      "descrRecursoV": args.descrRecursoV!=="Seleccionar..."?args.descrRecursoV:null,
      "tag": odes.tag,
      "horaSolic": odes.horaSolic,
      "nombreSolic": odes.nombreSolic,
      "fechaImpr": odes.fechaImpr,
      "usuarioImpr": odes.usuarioImpr,
      "fechaClose": fechaHoy,
      "horaClose": horaHoy.substr(0, 5),
      "usuarioClose": sessionStorage.getItem('userLogin'),
      "fechaCanc": odes.fechaCanc,
      "usuarioCanc": odes.usuarioCanc,
      "fechaEjec": odes.fechaEjec,
      "fechaFra": odes.fechaFra    
    }
    actEstOS.push(argsUpd)
    // console.log(argsUpd)
    // console.log(saldoCl)

    argsUpd = {
      "accionBD": this.props.editCliente,
      "tipoAct": "EditarCliOdeS",
      "_id": _idCli,
      "estadoCliente": estadoCi,
      "cargoMensual": nuevaRenta,
      "saldoPendiente": saldoCl,
    }
    actEstCl.push(argsUpd)

    let editMarquilla = []
    argsUpd = {
      "accionBD": this.props.editCliente,
      "tipoAct": "EditarMarquillaNodo",
      "_id": _idCli,
      "codigoMarquilla": args.codigoMarquilla,
      "descrNodo": args.descrNodo?args.descrNodo:"",
      "codigoPaquete": args.codigoPaquete,
      "descrPaquete": args.descrPaquete,
      "noFactOSAb": updnoFactOSAb?false:cliente.noFactOSAb?cliente.noFactOSAb:false,
    }
    editMarquilla.push(argsUpd)
    // console.log(cliente.noFactOSAb, argsUpd)

    if((cliente.codigoMarquilla&&cliente.codigoMarquilla!==args.codigoMarquilla)||(!cliente.codigoMarquilla&&args.codigoMarquilla)){
      argsAddHC = {
        "fechaHistCliente": fechaHoy + ' ' + horaHoy,
        "contrato": cliente.contrato,
        "movimiento": "OS",
        "descripcion": `Marquilla Ant: ${cliente.codigoMarquilla?cliente.codigoMarquilla:""}`,
        "detalle": `Marquilla Nueva: ${args.codigoMarquilla?args.codigoMarquilla:""}`,
        "relacion": odes.numeroOS.toString(),
        "valor": 0,
        "usuarioCreate": sessionStorage.getItem('userLogin'),
      }
      updDoc.push(argsAddHC)
    }

    // console.log(servCF)
    // console.log(servCFI)
    // console.log(movCli)
    // console.log(movCliI)
    // console.log(servTarCli)
    // console.log(servTarCliI)

    // //Para agregar los servicios y sus imptos de CF en la OS
    numDocCRUD = 0
    totDocCRUD = servCF.length + servCFI.length
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editOdeSUpdDoc)
    }

    servCF.forEach((elemento, i) => {
      // console.log(elemento)

      argsCrud[numDocCRUD] = elemento
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

      // crudColecc[numDocCRUD] = this.props.editOdeSUpdDoc

      numDocCRUD += 1

      let imptosCF = servCFI.filter(imptos => imptos.numeroOS===elemento.numeroOS 
                                && imptos.codigoServicio===elemento.codigoServicio)
      imptosCF.forEach((elemento1, ii) => {
        argsCrud[numDocCRUD] = elemento1
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

        // crudColecc[numDocCRUD] = this.props.editOdeSUpdDoc

        numDocCRUD += 1
      })
    })

    // console.log(crudColecc)
    // console.log(argsCrud)
    if(totDocCRUD>0){
      await updColecc(crudColecc, argsCrud, totDocCRUD)
    }

    //Para agregar los movimCliente y despues los impuestos
    if(movCli.length>0){
      // console.log(movCli)
      let movCliMany = [], movCliMany1 = []
      movCli.forEach((elementoDX, ii) => {
        movCliMany.push(elementoDX)
      })
      movCliMany1.push({movcliente: movCliMany})

      numDocCRUD = 0
      // totDocCRUD = movCli.length + movCliI.length
      totDocCRUD = 1
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        if(this.props.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
          crudColecc.push(this.props.createMovCliCCMany)
        }else{
          crudColecc.push(this.props.createMovClientesMany)
        }
      }

      argsCrud[numDocCRUD] = movCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      if(this.props.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
        crudColecc[numDocCRUD] = this.props.createMovCliCCMany
      }else{
        crudColecc[numDocCRUD] = this.props.createMovClientesMany
      }

      // movCli.forEach((elemento, i) => {
      // console.log(elemento)
      //   argsCrud[numDocCRUD] = elemento
      //   argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      //   argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

      //   if(this.props.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
      //     crudColecc[numDocCRUD] = this.props.createMovCliCC
      //     // crudColecc[numDocCRUD] = this.props.createMovCliCCMany
      //   }else{
      //     crudColecc[numDocCRUD] = this.props.createMovClientes
      //     // crudColecc[numDocCRUD] = this.props.createMovClientesMany
      //   }
      //   numDocCRUD += 1

      //   let origen = "OS-" + elemento.numeroOS
      //   let imptosMC = movCliI.filter(imptos => imptos.origen===origen 
      //                                 && imptos.codigoServicio===elemento.codigoServicio)
      // console.log(imptosMC)
      //   imptosMC.forEach((elemento1, ii) => {
      //     argsCrud[numDocCRUD] = elemento1
      //     argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      //     argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

      //     numDocCRUD += 1
      //   })
      // })
      // if(totDocCRUD>0){
        // console.log(crudColecc)
        // console.log(argsCrud)
        await updColecc(crudColecc, argsCrud, totDocCRUD)
        // console.log("111111")
      // }
    }

    // Si tiene Concepto del nuevo cargo a próxima factura
    if(args.descrOtrosPagCl!=="Seleccionar..."&&args.stValor>0){
      // let response = await this.props.fecha({
      //   variables: {}
      // });
      // const {fechaHoraHoy} = response.data.fecha
      // let fechaHoy = fechaHoraHoy.substr(0, 10)
// console.log(fechaHoraHoy)
      let valorAntesI = args.stValor
      let valorImpto = 0
      if(args.descrImpto){
        valorAntesI = (valorAntesI / ((100 + Math.round(args.porcImpto))/100))
        valorAntesI = Math.round(valorAntesI)
        valorImpto = args.stValor - valorAntesI
      }

      movCliI = []
      argsUpd = {}
      if(args.codigoImpto!==null){
        argsUpd = {
          "codigoImpto": args.codigoImpto,
          "descrImpto": args.descrImpto,
          "porcImpto": args.porcImpto,
          "valorImpto": valorImpto,
        }
        movCliI.push(argsUpd)
      }

      let codigoServicio = args.descrOtrosPagCl
      movCli = []
      argsUpd = {
        "contrato": cliente.contrato,
        "fechaMov": fechaHoy,
        "tipo": "C",
        "subTipo": "NC",
        "procesado": args.stValor===0?"S":"N",
        "codigoServicio": codigoServicio,
        "nombreResumido": args.descrOtrosPagCl,
        "descripcionServicio": args.descrOtrosPagCl,
        "concepto": args.descrOtrosPagCl,
        "descrClaseServ": args.descrClaseServ,
        "periodo": fechaHoraHoy.substr(0, 7),
        "origen": "Nuevo cargo",
        "saldoCliente": saldoCl,
        "valorTotal": args.stValor,
        "valorAntesImptos": valorAntesI,
        "agno": fechaHoraHoy.substr(0, 4),
        "mes": fechaHoraHoy.substr(5, 2),
        "valorPagado": 0,
        "numeroOdeDX": 0,
        "usuarioCreate": sessionStorage.getItem('userLogin'),
        "fechaCreate": fechaHoraHoy,
        "imptos": movCliI,
      };
      // console.log(argsUpd)
      movCli.push(argsUpd)

      let movCliMany = [], movCliMany1 = []
      movCli.forEach((elementoDX, ii) => {
        movCliMany.push(elementoDX)
      })
      movCliMany1.push({movcliente: movCliMany})
      
      numDocCRUD = 0
      totDocCRUD = 1
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.createMovCliCCMany)
      }

      argsCrud[numDocCRUD] = movCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.createMovCliCCMany

      // console.log(crudColecc)
      // console.log(argsCrud)
      await updColecc(crudColecc, argsCrud, totDocCRUD)
      // FIN Si tiene Concepto del nuevo cargo a próxima factura
    }


    
    //SI HAY CARGOS NEG Y SALDOCL > 0 => APLICARLOS DCTOS EN LOS MOV MAS ANTIGUOS
    // console.log(saldoCl, valorPagNeg, this.props.comoAsigCargosAlCliente)
    if(valorPagNeg<0&&this.props.comoAsigCargosAlCliente==="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
      // console.log(this.props.list4)
      let listColecc = this.props.list4.filter(elemento => elemento.tipo==="C" && elemento.valorTotal!==elemento.valorPagado)
      listColecc = listColecc.map(recpago => ({...recpago}))

      listColecc = _.orderBy(listColecc, ['_id'], ['asc'])
      // console.log(listColecc)

      let movColecc = []
      if(saldoCl<=0){
        listColecc.forEach((elemento1, ii) => {
          argsUpd = {
            // "contrato": cliente.contrato,
            // "tipoAct": "EditarValPag",
            // "valorPagado": elemento1.valorTotal,

            "contrato": cliente.contrato,
            "_id": elemento1._id,
            "procesado": elemento1.procesado,
            "concepto": elemento1.concepto,
            "numeroFra": elemento1.numeroFra,
            "numeroRC": elemento1.numeroRC,
            "numeroCE": elemento1.numeroCE,
            "numeroOdeDX": elemento1.numeroOdeDX,
            "fechaUltPago": elemento1.fechaUltPago,
            "valorUltPago": elemento1.valorUltPago,
            "documento": elemento1.documento,
            "valorPagado": elemento1.valorTotal,
          }
          movColecc.push(argsUpd)
        })
      }else{
        valorPagNeg = valorPagNeg * -1
        listColecc.forEach((elemento, i) => {
          if(elemento.valorTotal<0){
            // console.log(elemento.valorTotal, valorPagNeg)
            valorPagNeg -= elemento.valorTotal
            listColecc[i].valorRecibido = elemento.valorTotal
          }
        })
        listColecc.forEach((elemento, i) => {
          if(elemento.valorTotal>0){
            if(valorPagNeg > elemento.valorTotal - elemento.valorPagado){
              // console.log(elemento.valorTotal, elemento.valorPagado, valorPagNeg)

              valorPagNeg -= (elemento.valorTotal - elemento.valorPagado)
              listColecc[i].valorRecibido = elemento.valorTotal - elemento.valorPagado
            }else{
              // console.log(elemento.valorTotal, elemento.valorPagado, valorPagNeg)

              listColecc[i].valorRecibido = valorPagNeg
              valorPagNeg = 0
            }
          }
        })
        // console.log(listColecc)
        listColecc.forEach((elemento1, ii) => {
          if(elemento1.valorRecibido&&elemento1.valorRecibido!==0){
            let valPagado = 0
            if(elemento1.valorPagado){
              valPagado = parseInt(elemento1.valorPagado, 10) + parseInt(elemento1.valorRecibido, 10)
            }else{
              valPagado = parseInt(elemento1.valorRecibido, 10)
            }
            argsUpd = {
              // "contrato": cliente.contrato,
              // "tipoAct": "EditarValPag",
              // "valorPagado": elemento1.valorTotal,

              "contrato": cliente.contrato,
              "_id": elemento1._id,
              "procesado": elemento1.procesado,
              "concepto": elemento1.concepto,
              "numeroFra": elemento1.numeroFra,
              "numeroRC": elemento1.numeroRC,
              "numeroCE": elemento1.numeroCE,
              "numeroOdeDX": elemento1.numeroOdeDX,
              "documento": elemento1.documento,
              "fechaUltPago": elemento1.fechaUltPago,
              "valorUltPago": elemento1.valorUltPago,
              "valorPagado": valPagado,
            }
            movColecc.push(argsUpd)
          }
        })
      }
      // console.log(movColecc)
      //Actualizar BD
      numDocCRUD = 0
      totDocCRUD = movColecc.length
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editMovClientes)
      }

      movColecc.forEach((elemento1, ii) => {
        argsCrud[numDocCRUD] = elemento1
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

        numDocCRUD += 1
      })
      if(totDocCRUD>0){
        // console.log(crudColecc)
        // console.log(argsCrud)
        updColecc(crudColecc, argsCrud, totDocCRUD)
      }
    }
    //FIN SI HAY CARGOS NEG Y SALDOCL > 0 => APLICARLOS DCTOS EN LOS MOV MAS ANTIGUOS

    //Para agregar los servicios de la tarifa y despues los impuestos de cada servicio en el cliente
    numDocCRUD = 0
    totDocCRUD = servTarCli.length + servTarCliI.length
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editClienteUpdDoc)
    }

    servTarCli.forEach((elemento, i) => {
      // console.log(elemento)
      argsCrud[numDocCRUD] = elemento
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

      // crudColecc[numDocCRUD] = this.props.editClienteUpdDoc

      numDocCRUD += 1

      let imptosTC = servTarCliI.filter(imptos => imptos.codigoTarifa===elemento.codigoTarifa 
                                    && imptos.codigoServicioT===elemento.codigoServicioT)
      imptosTC.forEach((elemento1, ii) => {
        argsCrud[numDocCRUD] = elemento1
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

        // crudColecc[numDocCRUD] = this.props.editClienteUpdDoc

        numDocCRUD += 1
      })
    })
    // console.log(crudColecc)
    // console.log(argsCrud)
    if(totDocCRUD>0){
      updColecc(crudColecc, argsCrud, totDocCRUD)
    }

    //Agregar los servicios de la oferta
    numDocCRUD = 0
    totDocCRUD = servOfCli.length
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editClienteUpdDoc)
    }
    servOfCli.forEach((elemento, i) => {
      // console.log(elemento)
      argsCrud[numDocCRUD] = elemento
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

      numDocCRUD += 1
    })
    // console.log(crudColecc)
    // console.log(argsCrud)
    if(totDocCRUD>0){
      updColecc(crudColecc, argsCrud, totDocCRUD)
    }

    //Si actualizó tarifa => numeroOdeDX = 0
    // console.log(actEstServCli)
    if(actEstServCli.length>0){
      // console.log("actualiza num DX")
      let actCliMany = []
      actEstServCli.forEach((elementoDX, ii) => {
        actCliMany.push(elementoDX)
      })
      let actCliMany1 = []
      actCliMany1.push({cliente: actCliMany})

      numDocCRUD = 0
      totDocCRUD = 1
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editClienteMany)
      }

      argsCrud[numDocCRUD] = actCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editClienteMany

      // console.log(argsCrud)
      updColecc(crudColecc, argsCrud, totDocCRUD)
    }
    if(actCFCli.length>0){
      // console.log("actualiza num DX")
      let actCliMany = []
      actCFCli.forEach((elementoCF, ii) => {
        actCliMany.push(elementoCF)
      })
      let actCliMany1 = []
      actCliMany1.push({cliente: actCliMany})
    
      numDocCRUD = 0
      totDocCRUD = 1
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editClienteMany)
      }
    
      argsCrud[numDocCRUD] = actCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editClienteMany
    
      // console.log(argsCrud)
      updColecc(crudColecc, argsCrud, totDocCRUD)
    }

    let promesas3 = updDir.map((elemento, i)=>this.actCli(elemento))
    // let promesas4 = servOfCli.map((elemento, i)=>this.actCli(elemento))
    let promesas8 = retEqCl.map((elemento, i)=>this.actEqu(elemento))
    let promesas9 = servEqCl.map((elemento, i)=>this.actCli(elemento))
    let promesas10 = eqNvos.map((elemento, i)=>this.actEqu(elemento))
    let promesas11 = elimEq.map((elemento, i)=>this.actCli(elemento))
    let promesas12 = actCliente.map((elemento, i)=>this.actCli(elemento))
    asyncCall(promesas3, function(){
      // asyncCall(promesas4, function(){
        asyncCall(promesas8, function(){
          asyncCall(promesas9, function(){
            asyncCall(promesas10, function(){
              asyncCall(promesas11, function(){
                asyncCall(promesas12, function(){
                  console.log("FIN")
                })
              })
            })
          })
        })
      // })
    })

    //Actualizar el estado de la OS
    // let response
    response = await this.props.editOdeS({
      variables: actEstOS[0]
    });
    // let {errors, success} = response.data.editOdeS;
    // if (!success){
    //   this.setState({errorAdd: errors})
    // }

    //Actualizar el estado del cliente
    response = await this.props.editCliente({
      variables: actEstCl[0]
    });

    //Actualizar Marquilla del cliente
    response = await this.props.editCliente({
      variables: editMarquilla[0]
    });

    // console.log(estadoCi)
    // console.log(cliente.estadoCliente)
    //Actualizar fechas clientes
    argsUpdClFe.fechaUltOSAb = null
    argsUpdClFe.fechaUltOSCe = fechaHoy
    if(cliente.estadoCliente!==estadoCi){
      argsAddHC = {
        "fechaHistCliente": fechaHoy + ' ' + horaHoy,
        "contrato": cliente.contrato,
        "movimiento": "OS",
        "descripcion": `Cambia estado`,
        "detalle": `${cliente.estadoCliente} => ${estadoCi}`,
        "relacion": odes.numeroOS.toString(),
        "valor": 0,
        "usuarioCreate": sessionStorage.getItem('userLogin'),
      }
      updDoc.push(argsAddHC)

      argsUpdClFe.estadoAnterior = cliente.estadoCliente
      if(cliente.estadoCliente==="ACTIVO"&&estadoCi!=="NUEVO"){
        argsUpdClFe.fechaUltDX = fechaHoy
      }
      if(cliente.estadoCliente!=="ACTIVO"&&cliente.estadoCliente!=="NUEVO"&&estadoCi==="ACTIVO"){
        argsUpdClFe.fecgaUltRX = fechaHoy
      }
    }
    if((cliente.estadoCliente==="NUEVO"&&estadoCi==="ACTIVO")||(estadoCi==="ACTIVO"&&!cliente.fechaPrimeraActivacion)){
      argsUpdClFe.fechaPrimeraActivacion = fechaHoy
    }

    actFechas.push(argsUpdClFe)

    numDocCRUD = 0
    totDocCRUD = 1
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editCliente)
    }
    argsCrud[numDocCRUD] = actFechas[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.editCliente

    updColecc(crudColecc, argsCrud, totDocCRUD)


    //Crear los registros en histclientes
    let updDocMany = [], updDocMany1 = []

    // console.log(updDoc)
    // fechaHoraHoy = fechaHoy + ' ' + horaHoy
    // let detalleCH = `${cliente.estadoCliente} => ${estadoCi}`
    let argsIns = `[{`
    updDoc.forEach((elementoDoc, ii) => {
      if(ii>0){
        argsIns += `, {`
      }
      argsIns += `'fechaHistCliente': '${elementoDoc.fechaHistCliente}',
      'contrato': '${elementoDoc.contrato}',
      'movimiento': '${elementoDoc.movimiento}',
      'descripcion': '${elementoDoc.descripcion}',
      'detalle': '${elementoDoc.detalle}',
      'relacion': '${elementoDoc.relacion}',
      'valor': '${elementoDoc.valor}',
      'usuarioCreate': '${elementoDoc.usuarioCreate}'}`
    })
    argsIns += `]`
    // console.log(argsIns)

    let argsUpdDoc = {tipoqry: `${argsIns}`, modelo: 'models.HistCliente.insertMany'}
    let updDocCH = []
    updDocCH.push(argsUpdDoc)
    // console.log(updDocCH)

    updDocCH.forEach((elementoDoc, ii) => {
      updDocMany.push(elementoDoc)
    })
    updDocMany1.push({docum: updDocMany})

    numDocCRUD = 0
    totDocCRUD = 1
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      await crudColecc.push(this.props.updDocumMany)
    }

    argsCrud[numDocCRUD] = updDocMany1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.updDocumMany

    // console.log(argsCrud)
    await updColecc(crudColecc, argsCrud, totDocCRUD)

    // console.log(args.tipoOSDirAnt)
    if(odes.genOSDirAnt==="SI"&&args.tipoOSDirAnt&&args.tipoOSDirAnt!=="Seleccionar..."){
      // GENERAR OS A DIRECCION ANTERIOR
      // console.log(odes.genOSDirAnt)
      // console.log(args)
      // console.log(this.state.argsAdd)
      // console.log(cliente)

      
      let responseF = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = responseF.data.fecha
      let fechaHoy = fechaHoraHoy.substr(0, 10)
      let horaHoy = fechaHoraHoy.substr(11, 8)

      let numOS = await this.nextVal('odess')
      let listaOS = await this.props.allTiposOS.allTiposOS.filter(elemento => elemento.descrTipoOS===args.tipoOSDirAnt)
      // console.log(listaOS)
      let argsAddOS = {
        "codigoTipoOS": listaOS[0].codigoTipoOS,
        "descrTipoOS": args.tipoOSDirAnt,
        "ptosAdic": 0,
        "observacAB": args.observacABOS,
        "estadoOS": "ABIERTA",
        "nombreSolic": ""
      }
      argsAddOS['numeroOS'] = numOS
      argsAddOS['contrato'] = cliente.contrato
      argsAddOS['fechaEjec'] = fechaHoy
      argsAddOS['fechaFra'] = fechaHoy
      argsAddOS['fechaCreate'] = fechaHoy
      argsAddOS['horaSolic'] = horaHoy
      argsAddOS['codigoMarquilla'] = cliente.codigoMarquilla?cliente.codigoMarquilla:""
      argsAddOS['descrNodo'] = cliente.descrNodo?cliente.descrNodo:""
      argsAddOS['codigoPaquete'] = cliente.codigoPaquete?cliente.codigoPaquete:""
      argsAddOS['descrPaquete'] = cliente.descrPaquete?cliente.descrPaquete:""
      argsAddOS['genOSDirAnt'] = listaOS[0].genOSDirAnt
      argsAddOS['osQueLaGenero'] = odes.numeroOS
      const response = await this.props.createOdeS({
        variables: argsAddOS
      });
      const {errors, success} = response.data.createOdeS;
      if (!success){
        this.setState({errorAdd: errors})
      }
// console.log(argsAddOS)

      argsUpd = {
        "ctrlCampo": "CRUD",
        "ctrl_id": "NO_ID",
        "accionBD": this.props.editOdeSUpdDoc,
        "tipoAct": "EditarDirmayor",
        "numeroOS": numOS,
        // "_idDirmayor": this.state.argsAdd._id,
        "codigoDpto": cliente.dirmayor.codigoDpto,
        "descrDpto": cliente.dirmayor.descrDpto,
        "codigoDptoDANE": cliente.dirmayor.codigoDptoDANE,
        "codigoCiudad": cliente.dirmayor.ciudades.codigoCiudad,
        "nombreCiudad": cliente.dirmayor.ciudades.nombreCiudad,
        "codigoMunicipioDANE": cliente.dirmayor.ciudades.codigoMunicipioDANE,
        "codigoPostalDANE": cliente.dirmayor.ciudades.codigoPostalDANE,
        "codigoCiudadInterno": cliente.dirmayor.ciudades.codigoCiudadInterno,
        "codBarrasRdo": cliente.dirmayor.ciudades.codBarrasRdo,
        "codigoZona": cliente.dirmayor.ciudades.zonas.codigoZona,
        "nombreZona": cliente.dirmayor.ciudades.zonas.nombreZona,
        "codigoBarrio": cliente.dirmayor.ciudades.zonas.barrios.codigoBarrio,
        "nombreBarrio": cliente.dirmayor.ciudades.zonas.barrios.nombreBarrio,
        "codigoTipoDocT": cliente.dirmayor.ciudades.zonas.barrios.codigoTipoDocT,
        "numeroDocumT": cliente.dirmayor.ciudades.zonas.barrios.numeroDocumT,
        "descrRecursoT": cliente.dirmayor.ciudades.zonas.barrios.descrRecursoT,
        "codigoTipoDocR": cliente.dirmayor.ciudades.zonas.barrios.codigoTipoDocR,
        "numeroDocumR": cliente.dirmayor.ciudades.zonas.barrios.numeroDocumR,
        "descrRecursoR": cliente.dirmayor.ciudades.zonas.barrios.descrRecursoR,
      
        "descrTipoVia1": cliente.direccion.descrTipoVia1,
        "numeroTipoVia1": cliente.direccion.numeroTipoVia1,
        "descrTipoVia2": cliente.direccion.descrTipoVia2,
        "numeroTipoVia2": cliente.direccion.numeroTipoVia2,
        "numeroTipoVia2F": cliente.direccion.numeroTipoVia2F,
        "descrTipoUnd1": cliente.direccion.descrTipoUnd1,
        "numeroTipoUnd1": cliente.direccion.numeroTipoUnd1,
        "descrTipoUnd2": cliente.direccion.descrTipoUnd2,
        "numeroTipoUnd2": cliente.direccion.numeroTipoUnd2,
        "descrTiUndMat": cliente.direccion.descrTiUndMat,
        "descrUndMat": cliente.direccion.descrUndMat
      };
      if(!cliente.direccion.descrTipoUnd1){delete argsUpd.descrTipoUnd1}
      if(!cliente.direccion.numeroTipoUnd1){delete argsUpd.numeroTipoUnd1}
      if(!cliente.direccion.descrTipoUnd2){delete argsUpd.descrTipoUnd2}
      if(!cliente.direccion.numeroTipoUnd2){delete argsUpd.numeroTipoUnd2}
      if(!cliente.direccion.descrTiUndMat){delete argsUpd.descrTiUndMat}
      if(!cliente.direccion.descrUndMat){delete argsUpd.descrUndMat}
      // console.log(argsUpd)

      totDocCRUD = 1
      argsCrud = []
      argsCrud[0] = argsUpd
      argsCrud[0]['ctrlCampo'] = 'CRUD'
      argsCrud[0]['ctrl_id'] = 'NO_ID'
    
      crudColecc = []
      crudColecc[0] = this.props.editOdeSUpdDoc

      // console.log(crudColecc)
      // console.log(argsCrud)
      await updColecc(crudColecc, argsCrud, totDocCRUD)








      // FIN GENERAR OS A DIRECCION ANTERIOR
    }




    this.setState({errorAdd: []})
    this.setState({argsAdd: {}})

    // setTimeout(async ()=>{
    //   await this.props.allOdeS.refetch()
    //   // await this.props.allMovClientes.refetch()
    // }, 1000)

    // await this.props.allOdeS.refetch()
    // await this.props.allMovClientes.refetch()
    this.estadosFalse()
    this.setState({showOS: true})
  }
}
//FINALIZA CERRAR O DE S

//CANCELAR LA OS
if(this.state.permiteCancel){
  opcWork = "Can"
  const errors = [];

  if(!args.observacCA){
    errors.push({path: 'O de S', message: `Por favor escriba la observación para cancelar`});
  }
  if(errors.length>0){
    this.setState({errorAdd: errors})
  }
  if(errors.length===0){
    // let fechaHoy = new Date()
    // // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha
    let fechaHoy = fechaHoraHoy.substr(0, 10)

    let editMarquilla = []
    const _idCli = cliente._id
    argsUpd = {
      "accionBD": this.props.editCliente,
      "tipoAct": "EditarMarquillaNodo",
      "_id": _idCli,
      "codigoMarquilla": cliente.codigoMarquilla?cliente.codigoMarquilla:"",
      "descrNodo": cliente.descrNodo?cliente.descrNodo:"",
      "codigoPaquete": cliente.codigoPaquete?cliente.codigoPaquete:"",
      "descrPaquete": cliente.descrPaquete?cliente.descrPaquete:"",
      "noFactOSAb": updnoFactOSAb?false:cliente.noFactOSAb?cliente.noFactOSAb:false,
    }
    // console.log(cliente.noFactOSAb, argsUpd)
    editMarquilla.push(argsUpd)
    response = await this.props.editCliente({
      variables: editMarquilla[0]
    });

    let odes = this.props.allOdeS.allOdeS.filter(elemento => elemento.numeroOS===this.state.idListaOS.numeroOS)
    // console.log(odes)
    numOS = odes[0].numeroOS
    argsUpd = {
      "numeroOS": odes[0].numeroOS,
      "estadoOS": "CANCELADA",
      "impresa": odes[0].impresa,
      "ptosAdic": odes[0].ptosAdic,
      "observacAB": odes[0].observacAB,
      "observacCE": odes[0].observacCE,
      "observacCA": args.observacCA,
      "horaSolic": odes.horaSolic,
      "nombreSolic": odes.nombreSolic,
      "fechaImpr": odes.fechaImpr,
      "usuarioImpr": odes.usuarioImpr,
      "fechaCanc": fechaHoy,
      "usuarioCanc": sessionStorage.getItem('userLogin'),    
      "fechaEjec": odes[0].fechaEjec,
      "fechaFra": odes[0].fechaFra    
    }
    // console.log(argsUpd)
    // let response
    response = await this.props.editOdeS({
      variables: argsUpd
    });
    let {errors, success} = response.data.editOdeS;
    if (!success){
      this.setState({errorAdd: errors})
    }

//Actualizar fechas clientes
    argsUpdClFe.fechaUltOSAb = null
    actFechas.push(argsUpdClFe)

    numDocCRUD = 0
    totDocCRUD = 1
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editCliente)
    }
    argsCrud[numDocCRUD] = actFechas[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.editCliente

    updColecc(crudColecc, argsCrud, totDocCRUD)

    this.setState({errorAdd: []})
    this.setState({argsAdd: {}})
    await this.props.allOdeS.refetch()
    this.estadosFalse()
    this.setState({showOS: true})
  }
}
//FINALIZA CANCELAR LA OS

// console.log(opcWork)
  if(opcWork!=="Dir"&&opcWork!=="Tar"&&opcWork!=="Ofe"&&opcWork!=="Equ"&&opcWork!=="Clo"&&opcWork!=="Can"){
    // console.log(opcWork)
// console.log(fechaF)
// console.log(fechaV)
    let pedirPtosAdic = "", genOSDirAnt = ""
    if(!args.observacAB||!fechaV||!fechaF||
      !args.descrTipoOS||args.descrTipoOS==="Seleccionar..."){
      let sinCampo='XXX'
      this.validarHandle(args.descrTipoOS, 'descrTipoOS', 'Seleccionar...', 'Debe seleccionar el tipo de O de S',
                        args.observacAB, 'observacAB', '', 'Debe escribir las observaciones',
                        fechaV, 'fechaEjec', '', 'Debe seleccionar  la fecha de ejecución',
                        fechaF, 'fechaFra', '', 'Debe seleccionar la fecha inicio de cargos',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '')
    }else{
      //ESTO PORQUE SE ESTAN CREANDO OS DUPLICADOS
      let horaEntradaAnt = sessionStorage.getItem('horaEntrada')
      let horaEntrada = new Date().getTime();
      let difHoraEntrada = 15000
      if(horaEntradaAnt){
        // console.log(horaEntradaAnt)
        difHoraEntrada = horaEntrada - horaEntradaAnt
      }else{
        difHoraEntrada = 19500
      }
      //

      const errors = [];
      if(difHoraEntrada>19000){
        argsList.forEach((elemento, _id) => {
          if(elemento.estadoLis===false){
            errors.push({path: 'recursos', message: `El recurso ${elemento.descrRecurso} esta seleccionado para quitar`});
          }
        })
        if(this.state.addOS){
          // Si ya existe una OS del mismo tipo, para crear otra del mismo tipo debe ser despues de 10 minutos
          let indexSearch = this.props.allOdeS.allOdeS.findIndex( odes => odes.estadoOS==="ABIERTA"&&
            odes.tipoos.descrTipoOS===args.descrTipoOS)
            // SE QUITA LA VALIDACION PORQUE EN BV PUEDEN CREAR DOS OS MANTENIMIENTO
            // AL MISMO CLIENTE Y NO ESTA DEJANDO. OJOOOOO REVISAR PARA QUE FUNCIONE
            // Y CONTROLANDO QUE NO SE CREEN OS DOBLES
            // if((indexSearch!==-1&&difHoraEntrada>600000)||indexSearch===-1){
          if((indexSearch!==-1)||indexSearch===-1){
            difHoraEntrada = 610000

            if(!args.descrCategOST||args.descrCategOST==="Seleccionar..."){
              let listaCatOS = await this.props.allCategOST.allCategOST.filter(elemento => elemento.descrTipoOS===args.descrTipoOS)
              if(listaCatOS.length>0){
                errors.push({path: 'Categoría', message: `Por favor seleccione la Categoría`});
              }
            }
  
            let tipoodes = this.props.allTiposOS.allTiposOS.filter(elemento => elemento.descrTipoOS===args.descrTipoOS)
            pedirPtosAdic = tipoodes[0].pedirPtosAdic
            genOSDirAnt = tipoodes[0].genOSDirAnt
            if(tipoodes[0].permTarServ!=="DEJAR IGUAL"||tipoodes[0].permOfertas!=='NO'){
              this.props.allTiposOS.allTiposOS.forEach((elemento1, _id) => {
                if(elemento1.permTarServ!=="DEJAR IGUAL"||elemento1.permOfertas!=='NO'){
                  const indexSearch = this.props.allOdeS.allOdeS.findIndex( odes => odes.estadoOS==="ABIERTA"&&
                    odes.tipoos.descrTipoOS===elemento1.descrTipoOS)
                  if(indexSearch!==-1){
                    errors.push({path: 'OdeS', message: `Tiene ABIERTA O de S ${this.props.allOdeS.allOdeS[indexSearch].numeroOS} de ${this.props.allOdeS.allOdeS[indexSearch].tipoos.descrTipoOS}, NO puede crear O de S de ${args.descrTipoOS}`});      
                  }
                }
              })
            }
          }
          // console.log(this.props.allOdeS.allOdeS)
          // console.log(args)
        }else{
          difHoraEntrada = 610000
        }
      }
      const fechaEjec = fechaV
      const fechaFra = fechaF

      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let fechaHoy = fechaHoraHoy.substr(0, 10)
      let horaHoy = fechaHoraHoy.substr(11, 8)
  
      if(errors.length>0){
        this.setState({errorAdd: errors})
      }

      if(errors.length===0&&difHoraEntrada>600000){
        sessionStorage.setItem("horaEntrada", horaEntrada);

        // var numOS = 0
        if(this.state.addOS){
          // console.log(args)
          if(checkNoFactOsAb){
            // Si se marcó NO facturar si OS abierta
            let editMarquilla = []
            const _idCli = cliente._id
            argsUpd = {
              "accionBD": this.props.editCliente,
              "tipoAct": "EditarMarquillaNodo",
              "_id": _idCli,
              "codigoMarquilla": cliente.codigoMarquilla?cliente.codigoMarquilla:"",
              "descrNodo": cliente.descrNodo?cliente.descrNodo:"",
              "codigoPaquete": cliente.codigoPaquete?cliente.codigoPaquete:"",
              "descrPaquete": cliente.descrPaquete?cliente.descrPaquete:"",
              "noFactOSAb": checkNoFactOsAb,
            }
            editMarquilla.push(argsUpd)

            let response = await this.props.editCliente({
              variables: editMarquilla[0]
            });
          }

          let argsAdd = args
          // Actualiza email, telefono 1 y fecha de cumpleaños
          let datosConfirmados="NO"
          if(cliente.datosConfirmados){
            datosConfirmados=cliente.datosConfirmados
          }
          if(datosConfirmados==="NO"){
            let editDatosBas = []
            let argsUpdDB = {}
            argsUpdDB = {
              "accionBD": this.props.editCliente,
              "tipoAct": "EditarDatosBas",
              "contrato": cliente.contrato,
              "telefono1": argsAdd.telefono1?argsAdd.telefono1:cliente.telefono1?cliente.telefono1:"",
              "eMail": argsAdd.eMail?argsAdd.eMail:cliente.eMail?cliente.eMail:"",
              "fechaCumple": argsAdd.fechaCumple?argsAdd.fechaCumple:!cliente.fechaCumple?null:cliente.fechaCumple,
            }
            editDatosBas.push(argsUpdDB)
            await this.props.editCliente({
              variables: editDatosBas[0]
            });
          }
          // FIN Actualiza email, telefono 1 y fecha de cumpleaños

          let cun = ""
          if(argsAdd.codigoTipoOS==="PQR"){
            cun = await this.nextVal('cun')
            cun = `00000000000000${cun}`
            cun = cun.slice(-10)
            cun = `${this.props.empresa.IdentificadorOperador_CUN}-${fechaHoy.substr(2, 2)}-${cun}`
            // console.log(cun, argsAdd.codigoTipoOS)
          }

          let listaOS = listTOS.filter(elemento => elemento.descrTipoOS===argsAdd.descrTipoOS)
          if(listaOS[0].estadoAlCrear&&listaOS[0].estadoAlCrear==="CERRADA"){
            argsAdd['estadoOS'] = "CERRADA"
            argsAdd['fechaClose'] = fechaHoy
            argsAdd['horaClose'] = horaHoy.substr(0, 5)
            argsAdd['usuarioClose'] = sessionStorage.getItem('userLogin')
            argsAdd['observacCE'] = ""
          }
          argsAdd['numeroOS'] = await this.nextVal('odess')
          argsAdd['contrato'] = cliente.contrato
          argsAdd['cun'] = cun
          argsAdd['fechaEjec'] = fechaEjec
          argsAdd['fechaFra'] = fechaFra
          argsAdd['fechaCreate'] = fechaHoy
          argsAdd['horaSolic'] = horaSolic
          argsAdd['codigoMarquilla'] = cliente.codigoMarquilla?cliente.codigoMarquilla:""
          argsAdd['descrNodo'] = cliente.descrNodo?cliente.descrNodo:""
          argsAdd['codigoPaquete'] = cliente.codigoPaquete?cliente.codigoPaquete:""
          argsAdd['descrPaquete'] = cliente.descrPaquete?cliente.descrPaquete:""
          argsAdd['genOSDirAnt'] = genOSDirAnt
          if(!args.ptosAdic||pedirPtosAdic!=="SI"){
            argsAdd['ptosAdic'] = 0
          }
          if(!args.descrCategOST||args.descrCategOST==="Seleccionar..."){
            argsAdd['descrCategOST'] = ""
          }
          const response = await this.props.createOdeS({
            variables: argsAdd
          });
          const {errors, success} = response.data.createOdeS;
          if (!success){
            this.setState({errorAdd: errors})
          }
          numOS = argsAdd['numeroOS']
          // console.log(numOS, cliente.tarifa, cliente.estadoCliente, listaOS[0].estadoCerrarOS)
          if(cliente.tarifa&&cliente.tarifa.codigoTarifa&&(cliente.estadoCliente==="DESCONECTADO"||
              cliente.estadoCliente==="RETIRADO"|| cliente.estadoCliente==="SUSPENDIDO")&&
              listaOS[0].estadoCerrarOS==="ACTIVO"){
            // console.log("Agregar tarifa a la OS", numOS)

            let servTarCli=[], servTarCliI=[]
            cliente.tarifa.servicios.forEach((elemento, i) => {
              argsUpd = {}
              argsUpd = {
                "tipoAct": i===0?"EditarTarifa":"EditarServTar",
                "numeroOS": numOS,
                "codigoTarifa": cliente.tarifa.codigoTarifa,
                "descrTarifa": cliente.tarifa.descrTarifa,
                "cicloFact": cliente.cicloFact?cliente.cicloFact:null,
                "fechaVence": cliente.tarifa.fechaVence,
                "codigoServicioT": elemento.codigoServicio,
                "nombreResumidoT": elemento.nombreResumido,
                "descripcionServicioT": elemento.descripcionServicio,
                "_idSubclaseServT": elemento.subclaseserv._id,
                "codigoSubclaseServT": elemento.subclaseserv.codigoSubclaseServ,
                "descrSubclaseServT": elemento.subclaseserv.descrSubclaseServ,
                "_idClaseServT": elemento.subclaseserv.claseserv._id,
                "codigoClaseServT": elemento.subclaseserv.claseserv.codigoClaseServ,
                "descrClaseServT": elemento.subclaseserv.claseserv.descrClaseServ,
                "velEfecDownstream": elemento.velEfecDownstream,
                "velEfecUpstream": elemento.velEfecUpstream,
                "codigoTipoTec": elemento.codigoTipoTec,
                "descrTipoTec": elemento.descrTipoTec,
                "colorServicio": elemento.colorServicio,
                "estadoServicio": "A",
                "rango1NumServValorIni": elemento.rango1NumServValorIni,
                "rango1NumServValorFin": elemento.rango1NumServValorFin,
                "rango1Valor": elemento.rango1Valor,
                "rango2NumServValorIni": elemento.rango2NumServValorIni,
                "rango2NumServValorFin": elemento.rango2NumServValorFin,
                "rango2Valor": elemento.rango2Valor,
                "rango3NumServValorIni": elemento.rango3NumServValorIni,
                "rango3NumServValorFin": elemento.rango3NumServValorFin,
                "rango3Valor": elemento.rango3Valor,
                "numeroServicios": elemento.numeroServicios,
                "valorServicios": elemento.valorServicios,
                "valorAntesImptos": elemento.valorAntesImptos
              };
              servTarCli.push(argsUpd)
        // console.log(argsUpd)
              elemento.imptos.forEach((elemento1, ii) => {
                if(elemento1.codigoImpto!==null){
                  // console.log(elemento1)
                  argsUpd = {}
                  argsUpd = {
                    "tipoAct": ii===0?"CrearImpto1":"CrearImpto2",
                    "numeroOS": numOS,
                    "codigoTarifa": cliente.tarifa.codigoTarifa,
                    "codigoServicioT": elemento.codigoServicio,
                    "codigoImpto": elemento1.codigoImpto,
                    "descrImpto": elemento1.descrImpto,
                    "porcImpto": elemento1.porcImpto,
                    "valorImpto": elemento1.valorImpto,
                  }
                  // console.log(argsUpd)
                  servTarCliI.push(argsUpd)
                }
              })
            })
            numDocCRUD = 0
            totDocCRUD = servTarCli.length + servTarCliI.length
            argsCrud = []
            crudColecc = []
            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.editOdeSUpdDoc)
            }
        // console.log(totDocCRUD)
            servTarCli.forEach((elemento, i) => {
              // console.log(elemento)
              argsCrud[numDocCRUD] = elemento
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

              numDocCRUD += 1
        
              let imptosTC = servTarCliI.filter(imptos => imptos.codigoTarifa===elemento.codigoTarifa 
                                            && imptos.codigoServicioT===elemento.codigoServicioT)
              imptosTC.forEach((elemento1, ii) => {
                // console.log(elemento1)
                argsCrud[numDocCRUD] = elemento1
                argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
                argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            
                numDocCRUD += 1
              })
            })
            // console.log(crudColecc)
            // console.log(argsCrud, totDocCRUD)
            if(totDocCRUD>0){
              await updColecc(crudColecc, argsCrud, totDocCRUD)
            }
            



            // odesTarServ.forEach((elemento, i) => {
            //   argsUpd = {
            //     "tipoAct": i===0?"EditarTarifa":"EditarServTar",
            //     "codigoTarifa": odesCodTar,
            //     "descrTarifa": odesDescrTar,
            //     "fechaVence": fechaV,
            //     "codigoServicioT": elemento.codigoServicio,
            //     "nombreResumidoT": elemento.nombreResumido,
            //     "descripcionServicioT": elemento.descripcionServicio,
            //     "_idSubclaseServT": elemento.subclaseserv._id,
            //     "codigoSubclaseServT": elemento.subclaseserv.codigoSubclaseServ,
            //     "descrSubclaseServT": elemento.subclaseserv.descrSubclaseServ,
            //     "_idClaseServT": elemento.subclaseserv.claseserv._id,
            //     "codigoClaseServT": elemento.subclaseserv.claseserv.codigoClaseServ,
            //     "descrClaseServT": elemento.subclaseserv.claseserv.descrClaseServ,
            //     "velEfecDownstream": elemento.velEfecDownstream,
            //     "velEfecUpstream": elemento.velEfecUpstream,
            //     "codigoTipoTec": elemento.codigoTipoTec,
            //     "descrTipoTec": elemento.descrTipoTec,
            //     "colorServicio": elemento.colorServicio,
            //     "estadoServicio": "A",
            //     "rango1NumServValorIni": elemento.rango1NumServValorIni,
            //     "rango1NumServValorFin": elemento.rango1NumServValorFin,
            //     "rango1Valor": elemento.rango1Valor,
            //     "rango2NumServValorIni": elemento.rango2NumServValorIni,
            //     "rango2NumServValorFin": elemento.rango2NumServValorFin,
            //     "rango2Valor": elemento.rango2Valor,
            //     "rango3NumServValorIni": elemento.rango3NumServValorIni,
            //     "rango3NumServValorFin": elemento.rango3NumServValorFin,
            //     "rango3Valor": elemento.rango3Valor,
            //     "numeroServicios": elemento.numeroServicios,
            //     "valorServicios": elemento.valorServicios,
            //     "valorAntesImptos": elemento.valorAntesImptos
            //   };
            // //para manejarlo con array de promesas => para que se ejecuten todas y luego si vaya a imptos
            //   servTarCli.push(argsUpd)
            //   // console.log(argsUpd)
            // })





            // // ACTUALIZA EN odes
            // let updDoc = [], updDocMany = [], updDocMany1 = []

            // // argsAdd['tarifa'] = {codigoTarifa: elemTarifa[indexSearchT].codigoTarifa,
            // //   descrTarifa: elemTarifa[indexSearchT].descrTarifa,
            // //   fechaVence: fechaV,
            // //   servicios: servColecc}

            // let tarifa = cliente.tarifa
            // let argsMatch = `'numeroOS': ${argsAdd['numeroOS']}`
            // // let argsSet = `'tarifa': ${tarifa}`
            // let argsSet = `'tarifa': {codigoTarifa: '11',
            //   descrTarifa: '22'}`
            // let argsUpdCl1 = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.OdeS.updateMany'}
            // updDoc.push(argsUpdCl1)

            // console.log(argsSet)
            // updDocMany.push(updDoc[0])
            // updDocMany1.push({docum: updDocMany})
            // updDocMany = []

            // let numDocCRUD = 0, totDocCRUD = 1, argsCrud = [], crudColecc = []
            // for(let iii=0; iii<totDocCRUD; iii++){
            //   argsCrud.push({ctrlCampo: 'NO_CRUD'})
            // }
            // for(let iii=0; iii<totDocCRUD; iii++){
            //   crudColecc.push(this.props.updDocumMany)
            // }

            // argsCrud[numDocCRUD] = updDocMany1[0]
            // argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            // argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            // crudColecc[numDocCRUD] = this.props.updDocumMany

            // // console.log(argsCrud)
            // await updColecc(crudColecc, argsCrud, totDocCRUD)
            // // FIN ACTUALIZA EN odes
          }
// console.log(argsAdd)
//Actualizar fechas clientes
          argsUpdClFe.fechaUltOSAb = fechaHoy
          actFechas.push(argsUpdClFe)

          numDocCRUD = 0
          totDocCRUD = 1
          argsCrud = []
          crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editCliente)
          }
          argsCrud[numDocCRUD] = actFechas[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editCliente

          await updColecc(crudColecc, argsCrud, totDocCRUD)
        }
        // let argsUpd
        // let argsDel
        // console.log(args)
        if(this.state.permiteUpdate){
          let odes = this.props.allOdeS.allOdeS.filter(elemento => elemento.numeroOS===this.state.idListaOS.numeroOS)
        // console.log(odes[0])

          let editMarquilla = []
          const _idCli = cliente._id
          argsUpd = {
            "accionBD": this.props.editCliente,
            "tipoAct": "EditarMarquillaNodo",
            "_id": _idCli,
            "codigoMarquilla": cliente.codigoMarquilla?cliente.codigoMarquilla:"",
            "descrNodo": cliente.descrNodo?cliente.descrNodo:"",
            "codigoPaquete": cliente.codigoPaquete?cliente.codigoPaquete:"",
            "descrPaquete": cliente.descrPaquete?cliente.descrPaquete:"",
            "noFactOSAb": checkNoFactOsAb,
          }
          editMarquilla.push(argsUpd)

          let response = await this.props.editCliente({
            variables: editMarquilla[0]
          });

          numOS = args.numeroOS
          // console.log(args)
          let descrCategOST = ""
          if(args.descrCategOST&&args.descrCategOST!=="Seleccionar..."){
            descrCategOST = args.descrCategOST
          }

          argsUpd = {
            "numeroOS": args.numeroOS,
            "ptosAdic": args.ptosAdic,
            "observacAB": args.observacAB,
            "descrCategOST": descrCategOST,
            "fechaEjec": fechaEjec,
            "fechaFra": fechaFra,
            "impresa": args.impresa,
            // "numeroOS": odes[0].numeroOS,
            "estadoOS": "ABIERTA",
            // "observacCE": odes[0].observacCE,
            // "observacCA": odes[0].observacCA,
            "horaSolic": odes[0].horaSolic,
            "nombreSolic": odes[0].nombreSolic,
            "fechaImpr": odes[0].fechaImpr,
            "usuarioImpr": odes[0].usuarioImpr,
          }
          // console.log(argsUpd)
          response = await this.props.editOdeS({
            variables: argsUpd
          });
          const {errors, success} = response.data.editOdeS;
          if (!success){
            this.setState({errorAdd: errors})
          }
        }
        if(!this.state.permiteDelete){
          //update recursos en O de S
          let arraySupIni=this.state.lisSupIni
          arraySupIni.forEach((elemento, _id) => {
            let siExiste = false
            argsList.forEach((elemento1, _id) => {
              if(elemento._id===elemento1._id){
                siExiste = true
              }
            })
            if(siExiste===false){
              argsDel = {
                "tipoAct": "EliminarRecurso",
                "numeroOS": numOS,
                "_idRecurso": elemento._id,
              };
              this.actOdeS(argsDel)
            }
          })

          // console.log(arraySupIni)
          // console.log(argsList)
          const arrayInf = this.props.allRecurso.allRecurso
          argsList.forEach((elemento, _id) => {
            let siExiste = false
            arraySupIni.forEach((elemento1, _id) => {
              if(elemento._id===elemento1._id){
                siExiste = true
              }
            })
            if(siExiste===false){
              arrayInf.forEach((elemento2, _id) => {
                if(elemento._id===elemento2._id){
                  argsUpd = {
                    "tipoAct": "EditarRecursos",
                    "numeroOS": numOS,
                    "_idRecurso" : elemento._id,
                    "codigoTipoDoc" : elemento.codigoTipoDoc,
                    "numeroDocum" : elemento.numeroDocum,
                    "descrRecurso" : elemento.descrRecurso,
                    "_idTipoRec" : elemento._idTipoRec,
                    "descrTipoRec" : elemento.descrTipoRec,
                    "areaAprovech" : elemento.areaAprovech
                  };
                  this.actOdeS(argsUpd)
                }
              })
            }
          })

          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          await this.props.allOdeS.refetch()
          this.estadosFalse()
          this.setState({showOS: true})
        }
        // if(this.state.permiteDelete){
        //   const argsDel = {
        //     _id: args._id
        //   }
        //   await this.props.deleteEquipo({
        //     variables: argsDel
        //   });

        //   this.props.allEquipo.refetch()
        //   this.estadosFalse()
        //   this.setState({showEquipo: true})
        // }
      }
    }
  }
}

handleBodegaEqu = () => {
  var miLista = document.getElementById("miLista3");
  const argsAdd = this.state.argsAdd
  argsAdd['_idBodega'] = miLista.options[miLista.selectedIndex].value
  if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
    argsAdd['codigoBodega'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['descrBodega'] = miLista.options[miLista.selectedIndex].attributes[1].value
    argsAdd['estadoEquipo'] = "BODEGA"
  }else{
    argsAdd['descrBodega'] = "Seleccionar..."
  }
  this.setState({argsAdd});
  // console.log(argsAdd)
}

  handleTipoOSOS = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['ptosAdic'] = ""
    argsAdd['descrCategOST'] = "Seleccionar..."
    argsAdd['_idTipoOS'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoTipoOS'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['descrTipoOS'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }else{
      argsAdd['descrTipoOS'] = "Seleccionar..."
    }
    this.setState({argsAdd});
    // console.log(argsAdd)
  }

  handleTipoOSCateg = () => {
    var miLista = document.getElementById("miListaCateg");
    const argsAdd = this.state.argsAdd
    argsAdd['descrCategOST'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleCiudadDpto = () => {
    this.setState({argsAdd: {}})
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['descrDpto'] = miLista.options[miLista.selectedIndex].text
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['codigoDptoDANE'] = miLista.options[miLista.selectedIndex].attributes[1].value
      argsAdd['_id'] = miLista.options[miLista.selectedIndex].value
    }else{
      argsAdd['descrDpto'] = "Seleccionar..."
      argsAdd['codigoDpto'] = ""
      argsAdd['codigoDptoDANE'] = ""
      argsAdd['_id'] = ""
    }
    argsAdd['codigoCiudad'] = ""
    argsAdd['nombreCiudad'] = "Seleccionar..."
    argsAdd['codigoMunicipioDANE'] = ""
    argsAdd['codigoPostalDANE'] = ""
    argsAdd['codigoCiudadInterno'] = ""
    argsAdd['codBarrasRdo'] = ""

    argsAdd['codigoTipoDocT'] = ""
    argsAdd['codigoZona'] = ""
    argsAdd['numeroDocumT'] = ""
    argsAdd['nombreZona'] = ""
    argsAdd['nombreBarrio'] = "Seleccionar..."
    argsAdd['codigoBarrio'] = ""
    argsAdd['descrRecursoT'] = ""
    argsAdd['codigoTipoDocR'] = ""
    argsAdd['numeroDocumR'] = ""
    argsAdd['descrRecursoR'] = ""

    this.setState({argsAdd});
  }

  handleZonaCiudad = () => {
    const argsAdd = this.state.argsAdd

    let miLista = document.getElementById("miLista");
    argsAdd['descrDpto'] = miLista.options[miLista.selectedIndex].text
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['_id'] = miLista.options[miLista.selectedIndex].value
    }else{
      argsAdd['descrDpto'] = "Seleccionar..."
      argsAdd['codigoDpto'] = ""
      argsAdd['_id'] = ""
    }

    miLista = document.getElementById("miLista1");
    argsAdd['nombreCiudad'] = miLista.options[miLista.selectedIndex].text
    if(miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
      argsAdd['codigoCiudad'] = ""
      argsAdd['codigoMunicipioDANE'] = ""
      argsAdd['codigoPostalDANE'] = ""
      argsAdd['codigoCiudadInterno'] = ""
      argsAdd['codBarrasRdo'] = ""
    }else{
      argsAdd['codigoCiudad'] = miLista.options[miLista.selectedIndex].value
      argsAdd['codigoMunicipioDANE'] = miLista.options[miLista.selectedIndex].attributes[3].value
      argsAdd['codigoPostalDANE'] = miLista.options[miLista.selectedIndex].attributes[4].value
      argsAdd['codigoCiudadInterno'] = miLista.options[miLista.selectedIndex].attributes[1].value
      argsAdd['codBarrasRdo'] = miLista.options[miLista.selectedIndex].attributes[2].value
    }
    argsAdd['codigoTipoDocT'] = ""
    argsAdd['codigoZona'] = ""
    argsAdd['numeroDocumT'] = ""
    argsAdd['nombreZona'] = ""
    argsAdd['nombreBarrio'] = "Seleccionar..."
    argsAdd['codigoBarrio'] = ""
    argsAdd['descrRecursoT'] = ""
    argsAdd['codigoTipoDocR'] = ""
    argsAdd['numeroDocumR'] = ""
    argsAdd['descrRecursoR'] = ""

    this.setState({argsAdd});
  }

  handleBarrioZona = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreZona'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codigoZona'] = miLista.options[miLista.selectedIndex].value
    this.setState({argsAdd});
  }

  handleBarrioSel = () => {
    const argsAdd = this.state.argsAdd

    let miLista = document.getElementById("miLista");
    argsAdd['descrDpto'] = miLista.options[miLista.selectedIndex].text
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['_id'] = miLista.options[miLista.selectedIndex].value
    }else{
      argsAdd['descrDpto'] = "Seleccionar..."
      argsAdd['codigoDpto'] = ""
      argsAdd['_id'] = ""
    }

    miLista = document.getElementById("miLista1");
    argsAdd['nombreCiudad'] = miLista.options[miLista.selectedIndex].text
    if(miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
      argsAdd['codigoCiudad'] = ""
      argsAdd['codigoMunicipioDANE'] = ""
      argsAdd['codigoPostalDANE'] = ""
      argsAdd['codigoCiudadInterno'] = ""
      argsAdd['codBarrasRdo'] = ""
    }else{
      argsAdd['codigoCiudad'] = miLista.options[miLista.selectedIndex].value
      argsAdd['codigoMunicipioDANE'] = miLista.options[miLista.selectedIndex].attributes[3].value
      argsAdd['codigoPostalDANE'] = miLista.options[miLista.selectedIndex].attributes[4].value
      argsAdd['codigoCiudadInterno'] = miLista.options[miLista.selectedIndex].attributes[1].value
      argsAdd['codBarrasRdo'] = miLista.options[miLista.selectedIndex].attributes[2].value
    }

    miLista = document.getElementById("miLista3");
    if(miLista.options[miLista.selectedIndex].attributes[1]){
      let dato1 = miLista.options[miLista.selectedIndex].attributes[0].value
      let dato2 = miLista.options[miLista.selectedIndex].attributes[1].value

      let posic1 = dato1.indexOf("/")
      argsAdd['codigoTipoDocT'] = dato1.substr(0, posic1)
      argsAdd['codigoZona'] = dato1.substr(posic1+1)

      posic1 = dato2.indexOf("/")
      argsAdd['numeroDocumT'] = dato2.substr(0, posic1)
      argsAdd['nombreZona'] = dato2.substr(posic1+1)
    }
    argsAdd['nombreBarrio'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codigoBarrio'] = miLista.options[miLista.selectedIndex].value
//si miLista.options[miLista.selectedIndex].attributes[0] no existe pone codigoBarrio que es el value
//=> se valida por miLista.options[miLista.selectedIndex].attributes[1]
    // argsAdd['codigoTipoDocT'] = miLista.options[miLista.selectedIndex].attributes[1]?miLista.options[miLista.selectedIndex].attributes[0].value:null
    // argsAdd['numeroDocumT'] = miLista.options[miLista.selectedIndex].attributes[1]?miLista.options[miLista.selectedIndex].attributes[1].value:null
    argsAdd['descrRecursoT'] = miLista.options[miLista.selectedIndex].attributes[2]?miLista.options[miLista.selectedIndex].attributes[2].value:null
    argsAdd['codigoTipoDocR'] = miLista.options[miLista.selectedIndex].attributes[3]?miLista.options[miLista.selectedIndex].attributes[3].value:null
    argsAdd['numeroDocumR'] = miLista.options[miLista.selectedIndex].attributes[4]?miLista.options[miLista.selectedIndex].attributes[4].value:null
    argsAdd['descrRecursoR'] = miLista.options[miLista.selectedIndex].attributes[5]?miLista.options[miLista.selectedIndex].attributes[5].value:null

    // argsAdd['codigoZona'] = miLista.options[miLista.selectedIndex].attributes[6]?miLista.options[miLista.selectedIndex].attributes[6].value:null
    // argsAdd['nombreZona'] = miLista.options[miLista.selectedIndex].attributes[7]?miLista.options[miLista.selectedIndex].attributes[7].value:null
// console.log(argsAdd)
    this.setState({argsAdd});
  }

  handleListaGral = (ev, seleccLista) => {
    // console.log(seleccLista)
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    const argsAdd = this.state.argsAdd
    // if(ev.target.name==="tipovia1"){
    //   var miLista = document.getElementById("miLista4");
      argsAdd[seleccLista] = ev.target.value
    // }
    this.setState({argsAdd});
    // console.log(argsAdd)

  }

  idListaOS = (ev, idListaOS)=>{
    this.setState({idListaOS: idListaOS})
    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showOS) {
      this.setState({verOS: true})
      // console.log("idlista")
      this.lisSupInf(ev, idListaOS.numeroOS)
    }
  }

  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.permiteEstadosFalse()
    this.setState({permiteUpdate: true})
  }

  handleClickDel = (ev) => {
    ev.preventDefault()
    this.permiteEstadosFalse()
    this.setState({permiteDelete: true})
  }

  handleClickCan = (ev) => {
    ev.preventDefault()
    this.permiteEstadosFalse()
    this.setState({permiteCancel: true})
  }

  handleClickClose = (ev) => {
    ev.preventDefault()
    this.permiteEstadosFalse()
    this.setState({permiteClose: true})
  }

  handleClickDir = (ev) => {
    ev.preventDefault()
    this.permiteEstadosFalse()
    this.setState({permiteDir: true})
  }

  handleClickTar = (ev) => {
    ev.preventDefault()
    this.permiteEstadosFalse()
    this.setState({permiteTar: true})
  }

  handleClickOfer = (ev) => {
    ev.preventDefault()
    this.permiteEstadosFalse()
    this.setState({permiteOfer: true})
  }

  handleClickEqu = (ev) => {
    ev.preventDefault()
    this.permiteEstadosFalse()
    this.setState({permiteEqu: true})
  }

  async UNSAFE_componentWillMount(){
    if(this.state.hoy===""){
      let hoy = this.state.hoy
      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy} = await response.data.fecha
      hoy = fechaFechaHoy.substr(0,10)
      this.setState({hoy})
    }
  }

  async componentDidUpdate(prevState){
    if(this.state.idListaOS!==prevState.idListaOS){
      await this.props.allOdeS.refetch()
      if(this.props.allClientes2.allClientes){
        await this.props.allClientes2.refetch({contrato: this.props.idLista.contrato})
      // console.log(this.props.allClientes2.allClientes)
      }  
    }
    if(!this.state.argsAdd.codigoDpto){
      if(this.props.allDirmayor.allDirmayor){
        if(this.props.allDirmayor.allDirmayor.length===1){
          const argsAdd = this.state.argsAdd
          argsAdd['codigoDpto'] = this.props.allDirmayor.allDirmayor[0].codigoDpto
          argsAdd['descrDpto'] = this.props.allDirmayor.allDirmayor[0].descrDpto
          argsAdd['codigoDptoDANE'] = this.props.allDirmayor.allDirmayor[0].codigoDptoDANE
          argsAdd['_id'] = this.props.allDirmayor.allDirmayor[0]._id
          if(this.props.allDirmayor.allDirmayor[0].ciudades.length===1){
            argsAdd['nombreCiudad'] = this.props.allDirmayor.allDirmayor[0].ciudades[0].nombreCiudad
            argsAdd['codigoCiudad'] = this.props.allDirmayor.allDirmayor[0].ciudades[0].codigoCiudad
            argsAdd['codigoMunicipioDANE'] = this.props.allDirmayor.allDirmayor[0].ciudades[0].codigoMunicipioDANE
            argsAdd['codigoPostalDANE'] = this.props.allDirmayor.allDirmayor[0].ciudades[0].codigoPostalDANE
            argsAdd['codigoCiudadInterno'] = this.props.allDirmayor.allDirmayor[0].ciudades[0].codigoCiudadInterno
            argsAdd['codBarrasRdo'] = this.props.allDirmayor.allDirmayor[0].ciudades[0].codBarrasRdo
          }
          this.setState({argsAdd});
        }
      }
    }else{
      if(this.props.allDirmayor.allDirmayor&&!this.state.argsAdd.codigoCiudad){
        this.props.allDirmayor.allDirmayor.forEach((elemento, _id) => {
          if(elemento.codigoDpto===this.state.argsAdd.codigoDpto){
            elemento.ciudades.forEach((elemento1, _id) => {
              if(elemento.ciudades.length===1){
                const argsAdd = this.state.argsAdd
                argsAdd['nombreCiudad'] = elemento1.nombreCiudad
                argsAdd['codigoCiudad'] = elemento1.codigoCiudad
                argsAdd['codigoMunicipioDANE'] = elemento1.codigoMunicipioDANE
                argsAdd['codigoPostalDANE'] = elemento1.codigoPostalDANE
                argsAdd['codigoCiudadInterno'] = elemento1.codigoCiudadInterno
                argsAdd['codBarrasRdo'] = elemento1.codBarrasRdo
                this.setState({argsAdd});
              }
            })
          }
        })
      }
    }
  }

  render(){
    const {showOS, addOS, verOS,
          argsAdd, errorAdd, permiteUpdate, permiteDelete, permiteCancel, permiteClose, permiteDir,
          permiteTar, permiteOfer, permiteEqu, idListaOS, lisSup, lisSupIni, lisInf, lisInfIni, hoy} = this.state;        

    let fechaV
    // console.log(this.props.opcionOdeS)
    // console.log(this.state.argsAdd.fechaVence)
    // console.log(argsAdd.fechaVence)
    // console.log(argsAdd)
    if(!this.state.argsAdd.fechaVence){
      const fechaHoy = new Date()
      fechaV = (fechaHoy.getFullYear()+1) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    }else{
      fechaV = argsAdd.fechaVence
    }
    let lista = []
    let lista1 = []
    let lista1Cat = []
    let lista2 = []
    let lista3 = []
    let lista4 = []
    let lista5 = []
    let lista6 = []
    let lista7 = []
    let lista8 = []
    let lista8Fact = []
    let lista8CC = []
    let lista9 = []
    let lista10 = []
    let lista11 = []
    let lista12 = []
    let listaEstCerr = []
    let listaOPC = []
    let clienteSel = []
    
    const fechaHoy = new Date()
    let horaSolic = ((fechaHoy.getHours())<10?'0'+(fechaHoy.getHours()):(fechaHoy.getHours()))+":"+((fechaHoy.getMinutes())<10?'0'+(fechaHoy.getMinutes()):(fechaHoy.getMinutes()));
    const agno = (fechaHoy.getFullYear()).toString()
    const mes = (((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))).toString()
    // if(this.props.allClientes.allClientes){
    //   clienteSel = this.props.allClientes.allClientes.filter(elemento => elemento.contrato===this.props.contrato)
    //   clienteSel = clienteSel[0]
    // }
    clienteSel = this.props.idLista

    if(this.props.allClientes2.allClientes){
      if(this.props.allClientes2.allClientes.length===1){
        clienteSel = this.props.allClientes2.allClientes[0]
      }
    //   console.log(clienteSel)
    // console.log(this.props.allClientes2.allClientes)
    }

    let numOSAb = 0
    let listaImprContr = []
    if (this.state.showOS) {
      if(this.props.allOdeS.allOdeS){
        lista = this.props.allOdeS.allOdeS
        if(this.props.opcionOdeS==="ImprContr"){
          let numOS_ImprContr = 0
          for(let i=0; i<lista.length; i++){
            if(lista[i].estadoOS!=='CANCELADA'&&numOS_ImprContr===0&&lista[i].tarifa&&lista[i].tarifa.codigoTarifa&&
                lista[i].direccion&&lista[i].direccion.descrTipoVia1){
              listaImprContr.push(lista[i])
              numOS_ImprContr += 1
            }
          }
          lista = listaImprContr
        }
        // numOSAb = lista.filter(elemento => elemento.estadoOS==='ABIERTA').length

//aqui voy para validar que no se cree varias os, solo se permite para mantenimiento
        // let listaosab = lista.filter(elemento => elemento.estadoOS==='ABIERTA')
        // console.log(listaosab)
        // let listaTipoOS = []
        // if(this.props.allTiposOS.allTiposOS){lista = this.props.allTiposOS.allTiposOS}
        // listaosab.forEach((elemento, _id) => {

        // })
        // let listaTipoOS = lista.filter(elemento => elemento.descrTipoOS==='ABIERTA')


      }
    }
    if (this.state.addOS) {
      if(this.props.allTiposOS.allTiposOS){lista = this.props.allTiposOS.allTiposOS}
      if(this.props.allCategOST.allCategOST){lista1 = this.props.allCategOST.allCategOST}
      if(this.props.allOdeS.allOdeS){
        lista7 = this.props.allOdeS.allOdeS
        lista7 = lista7.filter(elemento => elemento.estadoOS==="ABIERTA")
      }
    }

    let ultMF = ""
    let tieneMCCMesAnt = true
    if (this.state.verOS) {
      if(this.props.allTiposOS.allTiposOS){
        lista = this.props.allTiposOS.allTiposOS
        lista = lista.filter(elemento => elemento.descrTipoOS===idListaOS.tipoos.descrTipoOS)

        switch(lista[0].estadoCerrarOS){
          case 'ACTIVO':
            listaEstCerr.push({estadoCierre: "ACTIVO"})
            break
          case 'DESCONECTADO':
            listaEstCerr.push({estadoCierre: "DESCONECTADO"})
            break
          case 'DESCONECTADO, SUSPENDIDO o RETIRADO':
            listaEstCerr.push({estadoCierre: "Seleccionar..."})
            listaEstCerr.push({estadoCierre: "DESCONECTADO"})
            listaEstCerr.push({estadoCierre: "SUSPENDIDO"})
            listaEstCerr.push({estadoCierre: "RETIRADO"})
            break
          case 'ACTIVO, DESCONECTADO, SUSPENDIDO o RETIRADO':
            listaEstCerr.push({estadoCierre: "Seleccionar..."})
            listaEstCerr.push({estadoCierre: "ACTIVO"})
            listaEstCerr.push({estadoCierre: "DESCONECTADO"})
            listaEstCerr.push({estadoCierre: "SUSPENDIDO"})
            listaEstCerr.push({estadoCierre: "RETIRADO"})
            break
          case 'DEJAR IGUAL':
            listaEstCerr.push({estadoCierre: clienteSel.estadoCliente})
            break
          default:
            break
        }
      }
      if(this.props.allCategOST.allCategOST){lista1Cat = this.props.allCategOST.allCategOST}
      if(this.props.allDirmayor.allDirmayor){lista1 = this.props.allDirmayor.allDirmayor}
      if(this.props.allTipoVia.allTipoVia){lista2 = this.props.allTipoVia.allTipoVia}
      if(this.props.allTipoUnd.allTipoUnd){lista3 = this.props.allTipoUnd.allTipoUnd}
      if(this.props.allTiUndMat.allTiUndMat){lista4 = this.props.allTiUndMat.allTiUndMat}
      if(this.props.allUndMat.allUndMat){lista5 = this.props.allUndMat.allUndMat}
      if(this.props.allTarifa.allTarifa){
        // console.log(clienteSel.tarifa.codigoTarifa)
        lista6 = this.props.allTarifa.allTarifa
        lista6 = lista6.filter(elemento => elemento.estadoTarifa===true||
          elemento.codigoTarifa===clienteSel.tarifa.codigoTarifa)
      }
      // if(this.props.list12){
      //   lista6 = this.props.list12
      //   lista6 = lista6.filter(elemento => elemento.estadoTarifa===true)
      // }
      if(this.props.allOferta.allOferta){
        lista9 = this.props.allOferta.allOferta
        lista9 = lista9.filter(elemento => elemento.estadoOferta===true)
      }
      if(this.props.allOdeS.allOdeS){
        lista7 = this.props.allOdeS.allOdeS
        lista7 = lista7.filter(elemento => elemento.numeroOS===idListaOS.numeroOS)
        // console.log(lista7)
      }
      // if(this.props.allMovClientes.allMovClientes){
      //   lista8 = this.props.allMovClientes.allMovClientes
      //   lista8 = lista8.filter(elemento => elemento.agno===agno && elemento.mes===mes)
      // }
      if(this.props.list4){
        lista8 = this.props.list4
        // console.log(this.props.list4)
        // console.log(agno)
        // console.log(mes)
        lista8 = lista8.filter(elemento => elemento.agno===agno && elemento.mes===mes)

        let agnoFact = (parseInt(agno, 10) + 1).toString()
        let mesFact = "01"
        if(mes!=="12"){
          agnoFact = agno
          mesFact = `0${(parseInt(mes, 10) + 1)}`
          mesFact = mesFact.slice(-2)
        }
        lista8Fact = this.props.list4.filter(elemento => elemento.agno===agnoFact && elemento.mes===mesFact && elemento.numeroFra)
        // console.log(lista8)
        // console.log(lista8Fact)
      }
      if(this.props.list4CC){
        // console.log(this.props.list4CC)
        lista8CC = this.props.list4CC

//PARA CUANDO SE FACTURA UN MES ANTERIOR
        let ultPF = this.props.allProcFact.allProcFact.filter(elemento => elemento.cicloFact===clienteSel.cicloFact)
        if(ultPF.length>0){
          ultMF = ultPF[ultPF.length-1].mes
        }
        let difmesesUMF = ((parseInt(agno, 10) * 12) + parseInt(mes, 10)) - ((parseInt(ultMF.substr(0,4), 10) * 12) + parseInt(ultMF.substr(5,2), 10))
// console.log(difmesesUMF)
//Si el la dif de meses entre hoy y el ult mes fact es > 1 => se verifica si el mes ant tiene mov
//en movcliccs
        if(difmesesUMF>1){
          let mesMA = parseInt(mes, 10)
          let agnoMA = agno
          if(mes==="01"){
            agnoMA = (parseInt(agno, 10) - 1).toString()
            mesMA = "12"
          }else{
            mesMA = (((mesMA-1)<10?'0'+(mesMA-1):(mesMA-1))).toString()
          }
// console.log(agnoMA + "-" + mesMA)
          let indexFrado = lista8CC.findIndex(servicio => (servicio.agno + "-" + servicio.mes)===(agnoMA + "-" + mesMA));
          if(indexFrado===-1){
//NO tiene mov del mes anterior en movcliccs => se pasa a veros2.js para que marque un detalle en movcliccs
//como NO FACTURAR
            tieneMCCMesAnt = false
          }  
        }
//FIN PARA CUANDO SE FACTURA UN MES ANTERIOR
// console.log(ultMF, tieneMCCMesAnt)

        lista8CC = lista8CC.filter(elemento => elemento.agno===agno && elemento.mes===mes)
      }

      if(this.props.allEquipo.allEquipo){
        lista10 = this.props.allEquipo.allEquipo
        lista10 = lista10.filter(elemento => elemento.estadoEquipo==='BODEGA')
      }
      if(this.props.allBodega.allBodega){lista11 = this.props.allBodega.allBodega}
      if(this.props.allRecurso.allRecurso){
        lista12 = this.props.allRecurso.allRecurso
        if(this.props.codigoDptoUA!=="Todos..."){
          lista12 = lista12.filter(elemento => elemento.codigoDpto===this.props.codigoDptoUA||elemento.codigoDpto==="Todos...")
        }
        if(this.props.codigoCiudadUA!=="Todas..."){
          lista12 = lista12.filter(elemento => elemento.codigoCiudad===this.props.codigoCiudadUA||elemento.codigoCiudad==="Todas...")
        }
        lista12 = lista12.filter(elemento => elemento.tiporec.areaAprovech==='VENTAS')
      }

      let claseServSig = "NoDefinida", claseServSig1 = ""
      if(clienteSel.tarifa.codigoTarifa){
        claseServSig = clienteSel.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
        clienteSel.tarifa.servicios.forEach((elemento, _id) => {
          claseServSig1 = elemento.subclaseserv.claseserv.descrClaseServ
          if(claseServSig1!==claseServSig){
            claseServSig = "NoDefinida"
          }
        })
      }
      if(this.props.listOPC){
        if(claseServSig!=="NoDefinida"){
          listaOPC = this.props.listOPC.filter(elemento => elemento.descrClaseServ===claseServSig)
        }else{
          listaOPC = this.props.listOPC
        }
      }
      // console.log(listaOPC, claseServSig)
    }

    // this.props.allOdeS.refetch(argsBuscar)
    // this.props.allMovClientes.refetch({contrato: this.props.contrato, agnoFra: agno, mesFra: mes})
// console.log(this.state)
// console.log(lista)    
// console.log(this.props.list4)
    // console.log(this.props.contrato)
    // console.log(clienteSel)
    // console.log(this.props.allEquipo.allEquipo)
// console.log(lista7)
// console.log(idListaOS.numeroOS)
// console.log(this.props.allOdeS1.allOdeS)
// console.log(this.props.allOdeS.allOdeS)
//     console.log(argsBuscar)
    // console.log(argsBuscarMC)
    // console.log(this.props.allDirmayor.allDirmayor)
    // console.log(this.props.allMovClientes.allMovClientes)
    // console.log(lista7)
    // console.log(idListaOS)
    // console.log(this.state)
    // console.log(errorAdd)
    // console.log(this.props.allTarifa.allTarifa)

//     console.log("render 1")

//     console.log(this.props.allOdeS.allOdeS)
//     console.log("createOdeS")
//     console.log("editOdeSUpdDoc")
//     console.log("editOdeS")
//     console.log("editClienteUpdDoc")
//     console.log("editCliente")
//     console.log("createMovClientes")
//     console.log("editMovClientesUpdDoc")
//     console.log(this.props.allDirmayor.allDirmayor)
//     console.log(this.props.allTiposOS.allTiposOS)
//     console.log(this.props.allRecurso.allRecurso)
//     console.log(this.props.allTiUndMat.allTiUndMat)
//     console.log(this.props.allTipoUnd.allTipoUnd)
//     console.log(this.props.allTipoVia.allTipoVia)
//     console.log(this.props.allUndMat.allUndMat)
//     console.log(this.props.allTarifa.allTarifa)
//     console.log(this.props.allOferta.allOferta)
//     console.log(this.props.allEquipo.allEquipo)
//     console.log("editEquipo")
//     console.log(this.props.allBodega.allBodega)
//     console.log("editSeqfindOneAndUpdate")
// console.log(this.props.list4CC)
// console.log("render 2")
// console.log(hoy)
// console.log(this.props.list3)
    return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showOS && <OdeSOS1 styles={this.props.styles} handleClickRegrOS={this.props.handleClickRegrOS}/>}
            {addOS && <AddOS1 styles={this.props.styles} handleClickRegr={this.showOS}/>}
            {verOS && <VerOS1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} list={lista}
                      idListaOS={lista7[0]} cliente={clienteSel} 
                      estado={idListaOS.estadoOS} handleClickRegr={this.showOS}
                      permiteUpdate={permiteUpdate} permiteDelete={permiteDelete} permiteCancel={permiteCancel}
                      permiteClose={permiteClose}  permiteDir={permiteDir}  permiteTar={permiteTar}
                      permiteOfer={permiteOfer}  permiteEqu={permiteEqu}S
                      handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}
                      handleClickCan={this.handleClickCan} handleClickClose={this.handleClickClose}
                      handleClickDir={this.handleClickDir} handleClickTar={this.handleClickTar}
                      handleClickOfer={this.handleClickOfer} handleClickEqu={this.handleClickEqu}
                      empresa={this.props.empresa} hoy={hoy}/>}

          </div>
          <div className="column" style={this.props.styles.boxDer}>
            {showOS && <OdeSOS2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                      list={lista} numOSAb={numOSAb} handleClick={this.addOS} cliente={clienteSel}
                      empresa={this.props.empresa}
                      opcionOdeS={this.props.opcionOdeS} handleClickidListaOS={this.idListaOS}/>}
            {addOS && <AddOS2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                      list={lista} list1={lista1} list7={lista7} cliente={clienteSel} lisSup={lisSup}
                      lisInf={lisInf} handleLista={this.handleTipoOSOS} handleLista1={this.handleTipoOSCateg}
                      handleSubmit={this.handleOS}
                      handleChange={this.handleChange} args={argsAdd} errors={errorAdd} horaSolic={horaSolic}/>}
            {verOS && <VerOS2 styles={this.props.styles} list={lista} list1={lista1} list1Cat={lista1Cat}
                      list3Estr={this.props.list3}
                      list2={lista2} list3={lista3} list4={lista4} list5={lista5} list6={lista6}
                      list7={lista7} list8={lista8} list8Fact={lista8Fact} list8CC={lista8CC}
                      list9={lista9} list10={lista10} list11={lista11}
                      list12={lista12} listaEstCerr={listaEstCerr} listaOPC={listaOPC}
                      cliente={clienteSel} lisSup={lisSup} lisInf={lisInf} lisInfIni={lisInfIni} lisSupIni={lisSupIni}
                      handleVrinic={this.addOS} handleSubmit={this.handleOS} args={argsAdd} errors={errorAdd}
                      handleQuitarTar={this.handleQuitarTar} handleQuitarDir={this.handleQuitarDir}
                      handleQuitarOf={this.handleQuitarOf} handleQuitarEqu={this.handleQuitarEqu}
                      permiteUpdate={permiteUpdate} permiteDelete={permiteDelete} permiteCancel={permiteCancel}
                      permiteClose={permiteClose} permiteDir={permiteDir} permiteTar={permiteTar}
                      permiteOfer={permiteOfer} permiteEqu={permiteEqu}
                      handleLista={this.handleCiudadDpto} handleLista1={this.handleZonaCiudad}
                      handleLista2={this.handleBarrioZona} handleLista3={this.handleBarrioSel}
                      handleLista4={this.handleListaGral} handleLista5={this.handleBodegaEqu}
                      handleChange={this.handleChange} handleCerrarWin={this.addOS}
                      argsSelDpto={argsAdd} argsBod={argsAdd} codigoCiudadUA={this.props.codigoCiudadUA}
                      codigoDptoUA={this.props.codigoDptoUA}
                      fechaV={fechaV} tieneMCCMesAnt={tieneMCCMesAnt} empresa={this.props.empresa}/>}

          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allOdeS, {name:'allOdeS', options: (argsBuscar) => {return {variables: argsBuscar}}}),
// graphql(queries.query.allOdeS, {name:'allOdeS1', options: (props) => {return {variables: {}}}}),

  // graphql(queries.mutation.createHistClienteMany, {name:'createHistClienteMany'}),
  graphql(queries.mutation.updDocumMany, {name:'updDocumMany'}),

  graphql(queries.mutation.createOdeS, {name:'createOdeS'}),
  graphql(queries.mutation.editOdeSUpdDoc, {name:'editOdeSUpdDoc'}),
  graphql(queries.mutation.editOdeS, {name:'editOdeS'}),
  // graphql(queries.mutation.deleteOdeS, {name:'deleteOdeS'}),
  graphql(queries.mutation.editClienteUpdDoc, {name:'editClienteUpdDoc'}),
  graphql(queries.mutation.editCliente, {name:'editCliente'}),

  graphql(queries.query.allClientes, {name:'allClientes2', options: (props) => {return {variables: {contrato: "XYZABC"}}}}),
  
  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),

  graphql(queries.mutation.createMovClientes, {name:'createMovClientes'}),
  graphql(queries.mutation.editMovClientesUpdDoc, {name:'editMovClientesUpdDoc'}),
  graphql(queries.mutation.createMovCliCC, {name:'createMovCliCC'}),
  graphql(queries.mutation.editMovCliCCUpdDoc, {name:'editMovCliCCUpdDoc'}),

  graphql(queries.mutation.createMovClientesMany, {name:'createMovClientesMany'}),
  graphql(queries.mutation.createMovCliCCMany, {name:'createMovCliCCMany'}),

  graphql(queries.mutation.editMovClientes, {name:'editMovClientes'}),

  graphql(queries.query.allDirmayor, {name:'allDirmayor', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allDirmayor, {name:'allDirmayor1', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allTiposOS, {name:'allTiposOS'}),
  graphql(queries.query.allRecurso, {name:'allRecurso', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allTiUndMat, {name:'allTiUndMat'}),
  graphql(queries.query.allTipoUnd, {name:'allTipoUnd'}),
  graphql(queries.query.allTipoVia, {name:'allTipoVia'}),
  graphql(queries.query.allUndMat, {name:'allUndMat', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allCategOST, {name:'allCategOST'}),

  graphql(queries.query.allTarifa, {name:'allTarifa', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allTarifa, {name:'allTarifa'}),

  // graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (argsBuscar) => {return {variables: argsBuscar}}}),
  graphql(queries.query.allOferta, {name:'allOferta', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allEquipo, {name:'allEquipo', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.editEquipo, {name:'editEquipo'}),
  graphql(queries.query.allBodega, {name:'allBodega', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allProcFact, {name:'allProcFact', options: (props) => {return {variables: {}}}}),

  // graphql(queries.mutation.createSequence, {name:'createSequence'}),
  // graphql(queries.mutation.editSequence, {name:'editSequence'}),
  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(HomeOdeS)
